var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProject10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 616.294,
    height: 358.622,
    viewBox: "0 0 616.294 358.622",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.3;}.b{fill:#aeaeae;}.c{fill:#a3a3a3;}.d{fill:#b7b7b7;}.e{fill:#8f8f8f;}.f{fill:#9f9f9f;}.g{fill:#7b7b7b;}.h{fill:#a0a0a0;}.i{fill:#acacac;}.j{fill:#747474;}.k{fill:#606060;}.l{fill:#cacaca;}.m{fill:#b6b6b6;}.n{fill:#969696;}.o{fill:#c1c1c1;}.p{fill:#b9b9b9;}.q{fill:#aaa;}.r{fill:#8b8b8b;}.s{fill:#646464;}.t{fill:#838383;}.u{fill:#818181;}.v{fill:#767676;opacity:0.4;mix-blend-mode:multiply;isolation:isolate;}.w{fill:#373737;}.x{fill:#787878;}.y{fill:#535353;}.z{fill:#434343;}.aa{fill:#7c7c7c;}.ab{fill:#959595;}.ac{fill:#a6a6a6;}.ad{fill:#dbdbdb;}.ae{fill:#bbb;}.af{fill:#5b5b5b;}.ag{fill:#797979;}.ah{fill:#8d8d8d;}.ai{fill:#d1d1d1;}.aj{fill:#919191;}.ak{fill:#e8a380;}.al,.au{fill:#e1e1e1;}.am{fill:#1a2e35;}.an{fill:#c98567;}.ao{fill:#455a64;}.ap{fill:#375a64;}.aq{fill:#de352c;}.ar{fill:#e0e0e0;}.as{fill:#db8471;}.at{fill:#c17163;}.au{stroke:#000;stroke-miterlimit:10;}.av{fill:#263238;}.aw{fill:#ffbe9d;}.ax{fill:#eb996e;}.ay{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.491 2406.718)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(2.491 -2406.718)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(437.927 63.922)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M684.43-2040.316H651.071V-2306.5H684.43Zm-30.526-2.6H681.6V-2303.9H653.9Z",
    transform: "translate(-578.351 2321.482)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 4.674,
    height: 263.582,
    transform: "translate(87.063 16.286)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 2.872,
    height: 263.582,
    transform: "translate(87.964 16.286)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117.822 13.85)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M716.242-2039.774h-7.887v-267.355l7.887-.809Z",
    transform: "translate(-708.355 2307.938)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 4.905,
    height: 267.355,
    transform: "translate(1.34 0.809)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.392 14.66)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 7.586,
    height: 267.355
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 4.905,
    height: 267.355,
    transform: "translate(1.34)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 92.564,
    height: 19.194,
    rx: 2.418,
    transform: "translate(43.118)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 16.403,
    height: 89.52,
    rx: 1.618,
    transform: "translate(134.16 1.396) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 16.008,
    height: 13.012,
    transform: "translate(81.643 1.648)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.008,
    height: 13.012,
    transform: "translate(81.643 0.741)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M729.17-2243.007l-8.531-45.671a11.363,11.363,0,0,0-6.774-8.32l-61.483-26.331c-.037-.016-.076-.022-.113-.036-.094-.036-.19-.065-.287-.092-.083-.022-.165-.044-.249-.059s-.194-.028-.293-.036-.168-.014-.253-.014a2.882,2.882,0,0,0-.3.017c-.083.008-.165.017-.248.031a2.96,2.96,0,0,0-.289.069c-.084.024-.167.049-.248.08-.043.016-.088.023-.131.042L588.492-2297a11.364,11.364,0,0,0-6.775,8.319l-8.531,45.672a2.645,2.645,0,0,0,2.327,3.017,3.165,3.165,0,0,0,.484.038,2.791,2.791,0,0,0,2.8-2.172l8.532-45.672a6.057,6.057,0,0,1,3.569-4.467l60.276-25.814,60.279,25.814a6.053,6.053,0,0,1,3.568,4.467l8.533,45.672a2.79,2.79,0,0,0,2.8,2.171,3.17,3.17,0,0,0,.484-.037A2.643,2.643,0,0,0,729.17-2243.007Z",
    transform: "translate(-561.778 2325.113)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.978 193.895)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 56.844,
    height: 85.973
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.626)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.844,
    height: 0.872
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.844,
    height: 0.872,
    transform: "translate(0 4.727)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.844,
    height: 0.872,
    transform: "translate(0 9.452)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.844,
    height: 0.872,
    transform: "translate(0 14.178)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.844,
    height: 0.872,
    transform: "translate(0 18.905)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.844,
    height: 0.872,
    transform: "translate(0 23.63)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.844,
    height: 0.872,
    transform: "translate(0 28.355)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.844,
    height: 0.872,
    transform: "translate(0 33.082)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.844,
    height: 0.872,
    transform: "translate(0 37.807)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.844,
    height: 0.872,
    transform: "translate(0 42.533)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.844,
    height: 0.872,
    transform: "translate(0 47.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.844,
    height: 0.872,
    transform: "translate(0 51.985)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.844,
    height: 0.872,
    transform: "translate(0 56.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.844,
    height: 0.872,
    transform: "translate(0 61.437)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.844,
    height: 0.872,
    transform: "translate(0 66.162)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.844,
    height: 0.872,
    transform: "translate(0 70.888)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 56.844,
    height: 0.872,
    transform: "translate(0 75.615)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.012 194.845)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 6.776,
    height: 2.726
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 6.776,
    height: 2.726,
    transform: "translate(0 4.822)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 6.776,
    height: 2.726,
    transform: "translate(0 9.645)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 6.776,
    height: 2.726,
    transform: "translate(0 14.468)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 6.776,
    height: 2.726,
    transform: "translate(0 19.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 6.776,
    height: 2.726,
    transform: "translate(0 24.016)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.173 223.51)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 6.776,
    height: 2.726
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 6.776,
    height: 2.726,
    transform: "translate(0 4.823)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M584.458-2199.982H561.819a1.974,1.974,0,0,1-1.407-.571,1.654,1.654,0,0,1-.486-1.339l1.739-16.7a1.846,1.846,0,0,1,1.892-1.579h19.164a1.846,1.846,0,0,1,1.892,1.579l1.739,16.7a1.663,1.663,0,0,1-.488,1.339A1.977,1.977,0,0,1,584.458-2199.982Zm-20.548-3.489h18.456l-1.374-13.213h-15.7Z",
    transform: "translate(-558.965 2303.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M584.2-2194.832H561.562a2.744,2.744,0,0,1-2.854-2.618,2.743,2.743,0,0,1,2.854-2.618H584.2a2.743,2.743,0,0,1,2.854,2.618A2.744,2.744,0,0,1,584.2-2194.832Z",
    transform: "translate(-558.708 2298.848)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 9.286,
    height: 6.712,
    rx: 0.646,
    transform: "translate(9.531 80.996)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M775-2199.982H752.36a1.978,1.978,0,0,1-1.408-.571,1.656,1.656,0,0,1-.485-1.339l1.739-16.7a1.846,1.846,0,0,1,1.892-1.579h19.164a1.846,1.846,0,0,1,1.892,1.579l1.738,16.7a1.656,1.656,0,0,1-.485,1.339A1.978,1.978,0,0,1,775-2199.982Zm-20.55-3.489H772.91l-1.377-13.213h-15.7Z",
    transform: "translate(-599.487 2303.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M774.744-2194.832H752.1a2.744,2.744,0,0,1-2.854-2.618,2.743,2.743,0,0,1,2.854-2.618h22.641a2.743,2.743,0,0,1,2.853,2.618A2.744,2.744,0,0,1,774.744-2194.832Z",
    transform: "translate(-599.23 2298.848)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 9.286,
    height: 6.712,
    rx: 0.646,
    transform: "translate(159.551 80.996)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 21.397,
    height: 2.848,
    transform: "translate(78.701 191.047)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 6.776,
    height: 2.848,
    transform: "translate(86.012 188.198)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M700.923-1969.781v1.989a1.517,1.517,0,0,1-1.579,1.466h-75.4a1.534,1.534,0,0,1-1.6-1.466v-1.989a.863.863,0,0,1,.1-.436,1.55,1.55,0,0,1,1.5-1.012h75.4a1.567,1.567,0,0,1,1.5,1.012A1.123,1.123,0,0,1,700.923-1969.781Z",
    transform: "translate(-572.243 2250.181)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M700.923-1969.944v2.425a1.517,1.517,0,0,1-1.579,1.466h-75.4a1.534,1.534,0,0,1-1.6-1.466v-2.425Z",
    transform: "translate(-572.243 2249.908)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.136 232.149)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 11.899,
    height: 41.354,
    transform: "translate(13.475 6.987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M686.628-2029.209v7.014a1.7,1.7,0,0,1-1.769,1.64h-35.3a1.711,1.711,0,0,1-1.769-1.64v-7.014a1.533,1.533,0,0,1,1.6-1.466h35.663A1.528,1.528,0,0,1,686.628-2029.209Z",
    transform: "translate(-647.789 2030.675)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M686.628-2029.209v1.989H647.789v-1.989a1.533,1.533,0,0,1,1.6-1.466h35.663A1.528,1.528,0,0,1,686.628-2029.209Z",
    transform: "translate(-647.789 2030.675)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "u",
    width: 22.824,
    height: 9.306,
    rx: 1.507,
    transform: "translate(8.012 43.165)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M7.3-1965.778H191.236c2.657,0,4.811-1.573,4.811-3.514h0c0-1.94-2.154-3.513-4.811-3.513H7.3c-2.657,0-4.811,1.573-4.811,3.513h0C2.491-1967.351,4.645-1965.778,7.3-1965.778Z",
    transform: "translate(-2.491 2314.438)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 175.751,
    height: 5.148,
    transform: "translate(9.324 280.349)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 175.751,
    height: 5.148,
    transform: "translate(9.324 332.939)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 4.092,
    height: 88.023,
    transform: "translate(146.617 260.638)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 4.092,
    height: 88.023,
    transform: "translate(9.214 260.638)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.83 242.697)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.593)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "y",
    cx: 16.954,
    cy: 16.954,
    r: 16.954,
    transform: "matrix(0.229, -0.973, 0.973, 0.229, 0, 33.009)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M33.747-2052.219a16.943,16.943,0,0,1-16.928-16.443c0,.172-.025.339-.025.512A16.953,16.953,0,0,0,33.747-2051.2,16.954,16.954,0,0,0,50.7-2068.15c0-.173-.02-.34-.026-.512A16.942,16.942,0,0,1,33.747-2052.219Z",
    transform: "translate(-13.363 2088.535)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M33.747-2088.718a16.943,16.943,0,0,1,16.933,16.539c0-.139.021-.274.021-.413a16.954,16.954,0,0,0-16.954-16.954,16.954,16.954,0,0,0-16.954,16.954c0,.139.017.275.02.413A16.943,16.943,0,0,1,33.747-2088.718Z",
    transform: "translate(-13.363 2092.976)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M44.021-2070.119a7.8,7.8,0,0,1-7.8,7.8,7.8,7.8,0,0,1-7.8-7.8,7.8,7.8,0,0,1,7.8-7.8A7.8,7.8,0,0,1,44.021-2070.119Z",
    transform: "translate(-15.835 2090.504)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.522 3.244)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "y",
    cx: 16.954,
    cy: 16.954,
    r: 16.954,
    transform: "matrix(0.256, -0.967, 0.967, 0.256, 0, 32.776)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M78.036-2052.219a16.943,16.943,0,0,1-16.928-16.443c0,.172-.026.339-.026.512A16.954,16.954,0,0,0,78.036-2051.2a16.954,16.954,0,0,0,16.954-16.953c0-.173-.02-.34-.026-.512A16.943,16.943,0,0,1,78.036-2052.219Z",
    transform: "translate(-57.303 2088.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M78.036-2088.718a16.943,16.943,0,0,1,16.933,16.539c0-.139.021-.274.021-.413a16.954,16.954,0,0,0-16.954-16.954,16.954,16.954,0,0,0-16.954,16.954c0,.139.018.275.021.413A16.943,16.943,0,0,1,78.036-2088.718Z",
    transform: "translate(-57.303 2093.325)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M88.31-2070.119a7.8,7.8,0,0,1-7.8,7.8,7.8,7.8,0,0,1-7.8-7.8,7.8,7.8,0,0,1,7.8-7.8A7.8,7.8,0,0,1,88.31-2070.119Z",
    transform: "translate(-59.776 2090.853)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.564 3.416)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "y",
    cx: 16.954,
    cy: 16.954,
    r: 16.954,
    transform: "translate(0 32.895) rotate(-75.959)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M122.326-2052.219a16.942,16.942,0,0,1-16.928-16.443c-.006.172-.026.339-.026.512a16.954,16.954,0,0,0,16.954,16.953,16.954,16.954,0,0,0,16.954-16.953c0-.173-.021-.34-.026-.512A16.943,16.943,0,0,1,122.326-2052.219Z",
    transform: "translate(-101.765 2088.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M122.326-2088.718a16.943,16.943,0,0,1,16.933,16.539c0-.139.021-.274.021-.413a16.954,16.954,0,0,0-16.954-16.954,16.954,16.954,0,0,0-16.954,16.954c0,.139.017.275.021.413A16.943,16.943,0,0,1,122.326-2088.718Z",
    transform: "translate(-101.765 2093.153)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M132.6-2070.119a7.8,7.8,0,0,1-7.8,7.8,7.8,7.8,0,0,1-7.8-7.8,7.8,7.8,0,0,1,7.8-7.8A7.8,7.8,0,0,1,132.6-2070.119Z",
    transform: "translate(-104.237 2090.681)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.019)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "y",
    cx: 16.954,
    cy: 16.954,
    r: 16.954,
    transform: "translate(0 23.977) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M166.616-2052.219a16.943,16.943,0,0,1-16.928-16.443c0,.172-.025.339-.025.512a16.954,16.954,0,0,0,16.954,16.953,16.954,16.954,0,0,0,16.954-16.953c0-.173-.02-.34-.025-.512A16.943,16.943,0,0,1,166.616-2052.219Z",
    transform: "translate(-142.639 2092.128)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M166.616-2088.718a16.944,16.944,0,0,1,16.934,16.539c0-.139.02-.274.02-.413a16.954,16.954,0,0,0-16.954-16.954,16.954,16.954,0,0,0-16.954,16.954c0,.139.017.275.02.413A16.943,16.943,0,0,1,166.616-2088.718Z",
    transform: "translate(-142.639 2096.569)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M176.89-2070.119a7.8,7.8,0,0,1-7.8,7.8,7.8,7.8,0,0,1-7.8-7.8,7.8,7.8,0,0,1,7.8-7.8A7.8,7.8,0,0,1,176.89-2070.119Z",
    transform: "translate(-145.111 2094.097)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135.89)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "y",
    cx: 16.954,
    cy: 16.954,
    r: 16.954,
    transform: "translate(0 23.977) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M210.905-2052.219a16.943,16.943,0,0,1-16.928-16.443c0,.172-.026.339-.026.512a16.954,16.954,0,0,0,16.954,16.953,16.954,16.954,0,0,0,16.954-16.953c0-.173-.02-.34-.026-.512A16.942,16.942,0,0,1,210.905-2052.219Z",
    transform: "translate(-186.929 2092.128)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M210.905-2088.718a16.943,16.943,0,0,1,16.933,16.539c0-.139.021-.274.021-.413a16.954,16.954,0,0,0-16.954-16.954,16.954,16.954,0,0,0-16.954,16.954c0,.139.018.275.021.413A16.943,16.943,0,0,1,210.905-2088.718Z",
    transform: "translate(-186.929 2096.569)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M221.18-2070.119a7.8,7.8,0,0,1-7.8,7.8,7.8,7.8,0,0,1-7.8-7.8,7.8,7.8,0,0,1,7.8-7.8A7.8,7.8,0,0,1,221.18-2070.119Z",
    transform: "translate(-189.401 2094.097)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.066 287.145)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.004)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "y",
    cx: 19.792,
    cy: 19.792,
    r: 19.792,
    transform: "matrix(0.242, -0.97, 0.97, 0.242, 0, 38.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M36.585-1988.025a19.777,19.777,0,0,1-19.762-19.194c-.006.2-.03.4-.03.6a19.791,19.791,0,0,0,19.792,19.792,19.792,19.792,0,0,0,19.792-19.792c0-.2-.024-.4-.03-.6A19.778,19.778,0,0,1,36.585-1988.025Z",
    transform: "translate(-12.599 2030.608)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M36.585-2030.632a19.78,19.78,0,0,1,19.768,19.308c0-.162.024-.32.024-.483A19.792,19.792,0,0,0,36.585-2031.6a19.792,19.792,0,0,0-19.792,19.792c0,.164.02.321.024.483A19.779,19.779,0,0,1,36.585-2030.632Z",
    transform: "translate(-12.599 2035.793)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M48.579-2008.921a9.108,9.108,0,0,1-9.108,9.108,9.108,9.108,0,0,1-9.108-9.108,9.108,9.108,0,0,1,9.108-9.108A9.108,9.108,0,0,1,48.579-2008.921Z",
    transform: "translate(-15.485 2032.907)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.827 5.181)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "y",
    cx: 19.792,
    cy: 19.792,
    r: 19.792,
    transform: "translate(0 39.032) rotate(-80.422)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M92.025-1988.025a19.778,19.778,0,0,1-19.762-19.194c-.006.2-.03.4-.03.6a19.792,19.792,0,0,0,19.792,19.792,19.791,19.791,0,0,0,19.792-19.792c0-.2-.024-.4-.03-.6A19.778,19.778,0,0,1,92.025-1988.025Z",
    transform: "translate(-69.216 2029.432)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M92.025-2030.632a19.78,19.78,0,0,1,19.768,19.308c0-.162.024-.32.024-.483A19.792,19.792,0,0,0,92.025-2031.6a19.792,19.792,0,0,0-19.792,19.792c0,.164.02.321.024.483A19.78,19.78,0,0,1,92.025-2030.632Z",
    transform: "translate(-69.216 2034.616)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M104.019-2008.921a9.108,9.108,0,0,1-9.108,9.108,9.108,9.108,0,0,1-9.108-9.108,9.108,9.108,0,0,1,9.108-9.108A9.108,9.108,0,0,1,104.019-2008.921Z",
    transform: "translate(-72.102 2031.73)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.296)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "y",
    cx: 19.792,
    cy: 19.792,
    r: 19.792,
    transform: "translate(0 27.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M147.466-1988.025a19.778,19.778,0,0,1-19.762-19.194c-.006.2-.031.4-.031.6a19.792,19.792,0,0,0,19.793,19.792,19.792,19.792,0,0,0,19.792-19.792c0-.2-.024-.4-.031-.6A19.777,19.777,0,0,1,147.466-1988.025Z",
    transform: "translate(-119.475 2034.612)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M147.466-2030.632a19.78,19.78,0,0,1,19.768,19.308c0-.162.024-.32.024-.483a19.792,19.792,0,0,0-19.792-19.792,19.792,19.792,0,0,0-19.793,19.792c0,.164.021.321.025.483A19.78,19.78,0,0,1,147.466-2030.632Z",
    transform: "translate(-119.475 2039.797)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M159.46-2008.921a9.108,9.108,0,0,1-9.108,9.108,9.108,9.108,0,0,1-9.108-9.108,9.108,9.108,0,0,1,9.108-9.108A9.108,9.108,0,0,1,159.46-2008.921Z",
    transform: "translate(-122.361 2036.911)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.946)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "y",
    cx: 19.792,
    cy: 19.792,
    r: 19.792,
    transform: "translate(0 27.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M202.906-1988.025a19.778,19.778,0,0,1-19.762-19.194c-.006.2-.03.4-.03.6a19.792,19.792,0,0,0,19.792,19.792,19.791,19.791,0,0,0,19.792-19.792c0-.2-.024-.4-.03-.6A19.778,19.778,0,0,1,202.906-1988.025Z",
    transform: "translate(-174.916 2034.612)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M202.906-2030.632a19.78,19.78,0,0,1,19.768,19.308c0-.162.024-.32.024-.483a19.792,19.792,0,0,0-19.792-19.792,19.792,19.792,0,0,0-19.792,19.792c0,.164.02.321.024.483A19.78,19.78,0,0,1,202.906-2030.632Z",
    transform: "translate(-174.916 2039.797)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M214.9-2008.921a9.108,9.108,0,0,1-9.108,9.108,9.108,9.108,0,0,1-9.108-9.108,9.108,9.108,0,0,1,9.108-9.108A9.108,9.108,0,0,1,214.9-2008.921Z",
    transform: "translate(-177.802 2036.911)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189.074)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.253 102.677)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M278.737-2166.325h-28a2.7,2.7,0,0,1-2.7-2.7,2.7,2.7,0,0,1,2.7-2.7h28a2.7,2.7,0,0,1,2.7,2.7A2.7,2.7,0,0,1,278.737-2166.325Z",
    transform: "translate(-248.039 2254.067)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M282.376-2271.782H262.747a2.262,2.262,0,0,1-2.263-2.262,2.262,2.262,0,0,1,2.263-2.263h19.629a2.262,2.262,0,0,1,2.263,2.263A2.262,2.262,0,0,1,282.376-2271.782Z",
    transform: "translate(-250.686 2276.307)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M280.555-2219.052H256.742a2.484,2.484,0,0,1-2.482-2.482,2.484,2.484,0,0,1,2.482-2.483h23.813a2.484,2.484,0,0,1,2.482,2.483A2.484,2.484,0,0,1,280.555-2219.052Z",
    transform: "translate(-249.362 2265.187)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M537.876-2271.15H519.353a2.2,2.2,0,0,1-2.2-2.2,2.2,2.2,0,0,1,2.2-2.2h18.523a2.2,2.2,0,0,1,2.2,2.2A2.2,2.2,0,0,1,537.876-2271.15Z",
    transform: "translate(-301.019 2378.822)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.151)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M462.87-2379.216a185.484,185.484,0,0,0-165.63,0l-2.06-4.108a190.11,190.11,0,0,1,169.751,0Z",
    transform: "translate(-287.962 2405.996)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M462.87-2382.612a185.494,185.494,0,0,0-165.63,0l-2.06-4.108a190.11,190.11,0,0,1,169.751,0Z",
    transform: "translate(-287.962 2406.718)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.109)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 11.903,
    height: 204.688
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 7.403,
    height: 204.688,
    transform: "translate(2.023)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(172.282 13.109)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 11.903,
    height: 204.688
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 7.403,
    height: 204.688,
    transform: "translate(2.023)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(173.572 36.988)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.664)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 16.293)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 32.587)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 48.88)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 65.173)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 81.467)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 97.76)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 114.053)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 130.347)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 146.64)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 162.934)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.224 36.988)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.664)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 16.293)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 32.587)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 48.88)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 65.173)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 81.467)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 97.76)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 114.053)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 130.347)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 146.64)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 162.934)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 1.727,
    height: 5.557,
    transform: "translate(7.273)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M492.926-2321.134H244.835a2.2,2.2,0,0,1-2.2-2.2,2.2,2.2,0,0,1,2.2-2.2h248.09a2.2,2.2,0,0,1,2.2,2.2A2.2,2.2,0,0,1,492.926-2321.134Z",
    transform: "translate(-242.637 2389.452)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 6.496,
    height: 52.706,
    rx: 1.056,
    transform: "translate(218.336 39.767)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 6.496,
    height: 52.706,
    rx: 1.056,
    transform: "translate(225.133 39.767)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 6.496,
    height: 52.706,
    rx: 1.056,
    transform: "translate(232.307 39.767)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ae",
    width: 6.496,
    height: 39.884,
    rx: 1.056,
    transform: "translate(27.654 126.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ae",
    width: 6.496,
    height: 39.884,
    rx: 1.056,
    transform: "translate(20.32 126.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ae",
    width: 6.496,
    height: 39.884,
    rx: 1.056,
    transform: "translate(12.38 126.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "af",
    width: 6.496,
    height: 21.665,
    rx: 1.056,
    transform: "translate(221.1 96.886)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "af",
    width: 6.496,
    height: 21.665,
    rx: 1.056,
    transform: "translate(228.609 96.886)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 6.496,
    height: 52.706,
    rx: 1.056,
    transform: "translate(27.654 39.767)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 6.496,
    height: 52.706,
    rx: 1.056,
    transform: "translate(20.32 39.767)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 6.496,
    height: 52.706,
    rx: 1.056,
    transform: "translate(12.986 39.767)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(213.259 1.855)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ag",
    width: 7.542,
    height: 241.438
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ah",
    width: 4.69,
    height: 241.438,
    transform: "translate(1.282)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(196.357 1.855)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ag",
    width: 4.403,
    height: 243.161
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ah",
    width: 2.738,
    height: 243.161,
    transform: "translate(0.748)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M409.088-2345.867c-.251-.021-.482-.021-.733-.021C408.669-2346.6,409.025-2346.349,409.088-2345.867Z",
    transform: "translate(-277.88 2393.876)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "aj",
    width: 27.369,
    height: 4.976,
    rx: 0.896,
    transform: "translate(194.667 0.711)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.341 -2327.659)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 47.594)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.171 70.498)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M126.127-2151.472l2.107,46.111,27.729-11.144s29.982-11.69,32.954-11.065l2.4,11.215-11.468,44.863-9.883-17.117s-43.2,20.131-51.088,18.9-15.349-16.217-14.71-19.908,8.7-66.7,8.7-66.7Z",
    transform: "translate(-104.126 2156.314)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.468 51.974)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M113.643-2153.773s-3.641-6.177-4.013-9.508,1.652-16.56,1.652-16.56l19.39,1.936,3.523,11.357-8.777,12.8-5.055.82Z",
    transform: "translate(-109.584 2179.841)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 46.735)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.598 0.235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M154.48-2178.256l-88.186,13.085-1-7.941,88.185-13.085Z",
    transform: "translate(-65.295 2186.197)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M154.319-2178.319a3.864,3.864,0,0,1-.107-.549c-.064-.411-.143-.917-.24-1.542q-.307-2.116-.844-5.821l.218.18c-14.275,2.319-48.36,7.518-88.139,13.421h0c-.1.134.819-1.173.432-.619v0l0,.008,0,.016,0,.032.008.064.017.128.032.254.064.51.128,1.016q.128,1.013.253,2.011c.167,1.331.331,2.637.49,3.9l-.568-.469,62.465-9.035,18.814-2.626,5.136-.684,1.353-.162a2.842,2.842,0,0,1,.487-.035,1.518,1.518,0,0,1-.409.1l-1.278.228-5,.82-18.657,2.933L66.2-2164.691l-.5.076-.068-.545c-.159-1.264-.324-2.569-.492-3.9q-.125-1-.253-2.012l-.128-1.016-.064-.509-.032-.255-.017-.127-.008-.064,0-.032,0-.016,0-.008v0c-.387.553.528-.755.434-.62h0c39.778-5.9,73.9-10.824,88.224-12.749l.2-.026.022.207q.407,3.8.64,5.974c.058.611.105,1.107.144,1.509A2.16,2.16,0,0,1,154.319-2178.319Z",
    transform: "translate(-64.536 2186.495)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.559 46.233)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M129.623-2176.021c.006-.316.42-8.947-.883-10.206s-3.614-1.252-4.152.3c0,0-2.7-2.645-4.673.068,0,0-2.7-2.49-4.537.32,0,0-2.759-2.071-3.75,2.619s-.856,8.919.368,9.694,2.928,1.6,3.281-1.513c0,0-.716,2.483.925,3.716s3.621,1.074,3.741-2.24c0,0,.447.838,1.991.8s2.017-2.481,2.16-3.774c0,0-.146,2.718,1.178,3.385A3.153,3.153,0,0,0,129.623-2176.021Z",
    transform: "translate(-110.97 2187.133)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.097 47.598)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M116-2173.83c-.276.013-.6-2.585-.531-5.8s.513-5.8.787-5.767.294,2.616.226,5.794S116.288-2173.843,116-2173.83Z",
    transform: "translate(-115.464 2185.399)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.458 47.899)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M122.084-2173.109c-.26.069-1.029-2.562-1.076-5.934-.067-3.374.617-6.034.881-5.974.286.054.066,2.7.132,5.953C122.064-2175.813,122.37-2173.174,122.084-2173.109Z",
    transform: "translate(-121.003 2185.017)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.449 47.004)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M127.786-2176.21c-.279-.017-.476-2.247-.439-4.98s.294-4.956.574-4.964.476,2.221.439,4.98S128.066-2176.193,127.786-2176.21Z",
    transform: "translate(-127.342 2186.154)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.148 54.631)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M137.125-2162.911a6.7,6.7,0,0,0,.517-6.033c-.923-2.432-2.489-6.015-4.016-7.007-2.377-1.542-10.923.866-10.923.866s.616,3.452,3.552,4.137,3.114,1.615,3.114,1.615l.25,1.852s-6.773-2.763-9.352,1.283a28.074,28.074,0,0,0-3.469,8.347l11.171,2.751s7.87-6.021,9.1-7.725C137.085-2162.852,137.106-2162.881,137.125-2162.911Z",
    transform: "translate(-116.798 2176.466)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.132 54.327)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M116.794-2157.932a4.489,4.489,0,0,1,.233-1.45,25.678,25.678,0,0,1,1.312-3.889,25.664,25.664,0,0,1,1.293-2.607,5.22,5.22,0,0,1,2.433-2.444c2.28-1,5.012-.645,7.709.3l-.585.3.972-3.186.4.673c-1.563-.105-3.064-.155-4.865-.324a3.737,3.737,0,0,1-2.4-1.678,7.265,7.265,0,0,1-1.088-2.851l-.094-.524.5-.094,2.276-.437a38.958,38.958,0,0,1,6.9-.709,6.784,6.784,0,0,1,1.753.24,3.119,3.119,0,0,1,1.535,1.125,13.6,13.6,0,0,1,1.7,3c.445,1.013.822,2.02,1.182,2.989a8.092,8.092,0,0,1,.584,3.141,6.806,6.806,0,0,1-.687,2.927,6.869,6.869,0,0,1-1.7,2.036c-2.407,2.128-4.464,3.638-5.885,4.7a12.519,12.519,0,0,1-2.283,1.516,14.927,14.927,0,0,1,2.052-1.863c1.342-1.157,3.347-2.775,5.648-4.938a6.213,6.213,0,0,0,1.483-1.847,5.955,5.955,0,0,0,.537-2.536,7.155,7.155,0,0,0-.568-2.763c-.374-.963-.758-1.944-1.2-2.917a12.845,12.845,0,0,0-1.579-2.743,2.147,2.147,0,0,0-1.088-.8,6.1,6.1,0,0,0-1.5-.185,39.786,39.786,0,0,0-6.714.718l-2.241.427.4-.618c.279,1.693,1.235,3.4,2.662,3.632,1.536.152,3.275.242,4.8.363l.6.047-.2.626c-.35,1.1-.692,2.17-1.011,3.172l-.149.465-.437-.163c-2.5-.933-5.131-1.3-7.1-.472a4.5,4.5,0,0,0-2.178,2.079,27.679,27.679,0,0,0-1.356,2.482C117.346-2159.894,116.9-2157.9,116.794-2157.932Z",
    transform: "translate(-116.778 2176.853)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.325 32.289)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M167.111-2165.727l-9.487,1.408-5.037-40.03,8.646-.494Z",
    transform: "translate(-152.587 2204.843)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.518 40.273)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M90.72-2154.672l-10.328,2.321-5.037-40.03,10.328-2.321Z",
    transform: "translate(-75.355 2194.702)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.793)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.712)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M244.356-2233.844c3.643-4.266,12.532-3.526,14.615-.671a6.546,6.546,0,0,1,8.855,3.3l9.442,2.348a9.464,9.464,0,0,1,4.526,2.039c1.23,1.2,1.79,3.409.754,4.807,3.325.977,4.584,6.381,2.086,8.956a4.118,4.118,0,0,1-.583,5.629,40.04,40.04,0,0,1,5.993,11.509,8.572,8.572,0,0,1,.424,5.42c-.609,1.731-2.725,2.906-4.1,1.807a4.888,4.888,0,0,1,.154,4.924c1.6.06,2.053,2.752.942,4s-2.9,1.365-4.5,1.308-3.334-.165-4.658.813a1.628,1.628,0,0,0,.512,1.108,7.567,7.567,0,0,1,1.382,9.754c-.194.288-.375.554-.533.794-.941,1.419-3.247,2.7-4.682,3.5-3.639,2.012-5.791,1.6-9.838,2.192,1.077,2.841-5.542,9.041-13,2.8-15.026,4.213-25.845,5.759-41.363,5.64-2.214-.017-4.872-.371-5.835-2.536a5.246,5.246,0,0,1-5.044-1.854,17.924,17.924,0,0,1-2.923-5.113,10.357,10.357,0,0,1-6.858-9.512,13.331,13.331,0,0,1-4.415-9.256c-3.717-1.273-5.725-6.548-3.919-10.3a48.423,48.423,0,0,1,4.733-14.138c-2.534-.622-3.456-4.349-2.389-6.921s3.392-4.208,5.6-5.7c-1.9.529-3.534-2.077-3.063-4.147s2.2-3.484,3.9-4.563a34.33,34.33,0,0,1,7.9-3.727c.936-3.618,5.243-7.7,8.386-9.279,12.678-6.35,21.534-7.9,37.5,5.065",
    transform: "translate(-181.123 2243.679)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.029 18.082)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M216.013-2203.679c1.09-9.424,7.527-20.641,16.151-19.059l26.681,9.269a5.488,5.488,0,0,1,4.248,5.934l-4.525,63.006c-.59,8.21-6.418,14.836-13.944,15.851h0c-9.64,1.3-18.105-6.978-17.924-17.526.075-4.334.122-7.59.12-7.57,0,0-11.016-2.758-12.419-18.682C213.7-2180.375,214.8-2193.209,216.013-2203.679Z",
    transform: "translate(-214.183 2222.888)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.02 34.682)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.58)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.738 7.769)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M221.467-2180.6a1.987,1.987,0,0,0,1.679,2.162,1.821,1.821,0,0,0,2.024-1.694,1.987,1.987,0,0,0-1.677-2.163A1.823,1.823,0,0,0,221.467-2180.6Z",
    transform: "translate(-221.459 2182.309)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M219.276-2190.285c.216.28,1.692-.759,3.7-.619,2,.11,3.41,1.329,3.643,1.077.113-.111-.094-.6-.706-1.153a4.9,4.9,0,0,0-2.9-1.188,4.632,4.632,0,0,0-2.96.822C219.405-2190.874,219.169-2190.411,219.276-2190.285Z",
    transform: "translate(-219.251 2192.176)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.322 1.736)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.588)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M243.8-2179.895a1.986,1.986,0,0,0,1.679,2.161,1.821,1.821,0,0,0,2.024-1.694,1.988,1.988,0,0,0-1.678-2.163A1.822,1.822,0,0,0,243.8-2179.895Z",
    transform: "translate(-243.792 2181.604)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.355)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M244.268-2188.081c.217.279,1.694-.759,3.7-.618,2,.109,3.411,1.328,3.643,1.077.113-.111-.092-.6-.706-1.153a4.891,4.891,0,0,0-2.9-1.188,4.632,4.632,0,0,0-2.96.821C244.4-2188.669,244.162-2188.206,244.268-2188.081Z",
    transform: "translate(-244.244 2189.971)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.485 1.204)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M232.508-2172.575a12.484,12.484,0,0,0-3.219-.857c-.509-.092-.987-.235-1.051-.62a3.017,3.017,0,0,1,.435-1.624q.839-1.969,1.756-4.129c2.446-5.883,4.252-10.735,4.033-10.839s-2.38,4.578-4.826,10.461q-.886,2.178-1.694,4.159a3.455,3.455,0,0,0-.391,2.164,1.346,1.346,0,0,0,.8.869,3.216,3.216,0,0,0,.862.19A12.023,12.023,0,0,0,232.508-2172.575Z",
    transform: "translate(-227.488 2190.647)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.629 40.615)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M230.228-2136.27A34.444,34.444,0,0,0,250-2140.591s-5.338,10.514-19.789,8.058Z",
    transform: "translate(-230.211 2140.591)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.322 0.799)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M243.8-2199.4c.164.6,2.181.459,4.515.926,2.343.416,4.2,1.291,4.538.781.154-.245-.145-.823-.879-1.448a7.342,7.342,0,0,0-3.311-1.515,7.056,7.056,0,0,0-3.586.214C244.191-2200.122,243.731-2199.687,243.8-2199.4Z",
    transform: "translate(-243.793 2200.789)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.118)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M220.713-2199.774c.324.518,1.734.1,3.4.186,1.664.025,3.047.539,3.4.044.156-.242-.038-.752-.624-1.26a4.473,4.473,0,0,0-2.713-1,4.437,4.437,0,0,0-2.763.811C220.793-2200.522,220.571-2200.026,220.713-2199.774Z",
    transform: "translate(-220.672 2201.804)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.156 12.218)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M208.042-2197.8a11.363,11.363,0,0,1,2.52-6.751,38.423,38.423,0,0,0,2.74-2.774c1.674-2.3,1.494-5.548,2.234-8.369a11.564,11.564,0,0,1,6.93-7.892c2.745-1.006,5.833-.805,8.415-2.231,1.909-1.054,3.378-2.918,5.342-3.848,3.822-1.811,8.188.386,11.734,2.771.661,3.1-1.183,5.742-2.958,8.276a9.953,9.953,0,0,1-7.55,4.284c-2.273.105-4.916-.5-6.541,1.228-1.709,1.819-1.11,5.092-2.524,7.188-2.022,3-6.492,1.756-9.474,3.576-2.3,1.4-3.308,4.348-4.5,6.909s-3.217,5.217-5.852,5.031A35.021,35.021,0,0,1,208.042-2197.8Z",
    transform: "translate(-207.994 2230.335)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.361 21.173)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M251.438-2218.962a48.044,48.044,0,0,1,19.408,4.183c1.83.816,3.719,1.845,4.741,3.686a10.733,10.733,0,0,1,.926,5.494c-.159,5.912-2.468,13.108-4.633,18.536l-6.871,4.29c-5.215-1.445-2.652-11.217-2.32-16.133a11.731,11.731,0,0,1-6.085-10.379A13.118,13.118,0,0,1,251.438-2218.962Z",
    transform: "translate(-251.438 2218.962)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.722 52.078)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M268.747-2176.548c.261-3.377,4.095-3.961,6.743-2.167,1.454.984,2.53,2.9,2.282,6.484-.661,9.564-9.367,6.872-9.364,6.6C268.41-2165.806,268.442-2172.593,268.747-2176.548Z",
    transform: "translate(-268.408 2179.709)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.653 55.31)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M272.14-2168.167c.041-.028.146.129.4.28a1.432,1.432,0,0,0,1.146.119c.956-.3,1.85-1.836,2.012-3.556a5.967,5.967,0,0,0-.265-2.42,1.888,1.888,0,0,0-1.066-1.373.759.759,0,0,0-.937.383c-.136.258-.094.453-.142.467-.026.021-.178-.177-.08-.565a1.076,1.076,0,0,1,.387-.572,1.085,1.085,0,0,1,.865-.174,2.255,2.255,0,0,1,1.5,1.613,6.112,6.112,0,0,1,.348,2.709c-.189,1.923-1.223,3.652-2.523,3.948a1.554,1.554,0,0,1-1.386-.368C272.14-2167.935,272.109-2168.152,272.14-2168.167Z",
    transform: "translate(-272.13 2175.604)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.02 20.557)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M272.148-2171.467a6.762,6.762,0,0,0,1.416-.073,4.878,4.878,0,0,0,1.552-.477l-.1-.06a4.87,4.87,0,0,0,2.278,3.52,4.16,4.16,0,0,0,4.656-.361l-.149-.031a1.825,1.825,0,0,0,1.142.859,2.321,2.321,0,0,0,1.431-.1,2.343,2.343,0,0,0,1.165-.991,3.524,3.524,0,0,0,.473-1.568,5.194,5.194,0,0,0-.908-3.212,13.9,13.9,0,0,0-2.285-2.5l-.019.221a3.387,3.387,0,0,0,1.436-2.242,5.309,5.309,0,0,0-.206-2.829,7.642,7.642,0,0,0-1.5-2.418,21.579,21.579,0,0,0-2.056-1.958l.01.217a3.779,3.779,0,0,0,.914-2.762,5.474,5.474,0,0,0-.95-2.863,11.886,11.886,0,0,0-4.248-3.341l.068.166a6.872,6.872,0,0,0-1.294-5.884,5.716,5.716,0,0,0-4.938-2.086l.133.166a5.822,5.822,0,0,0-1.116-4.681,4.86,4.86,0,0,0-3.693-2.059l.109.123a5.546,5.546,0,0,0-1.934-4.213,4.583,4.583,0,0,0-3.667-1.176l.1.1a5.6,5.6,0,0,0-.676-2.47,6.719,6.719,0,0,0-1.309-1.782,4.884,4.884,0,0,0-2.993-1.47l-.331-.031c-.107,0-.21.014-.311.02a4.119,4.119,0,0,0-.559.059,5.628,5.628,0,0,0-.846.242l-.5.219a1.022,1.022,0,0,0-.165.083.962.962,0,0,0,.174-.058l.5-.194a6.135,6.135,0,0,1,.842-.214,4.157,4.157,0,0,1,.551-.047c.1,0,.2-.015.306-.013l.324.036a4.818,4.818,0,0,1,2.909,1.478,6.581,6.581,0,0,1,1.265,1.755,5.446,5.446,0,0,1,.639,2.384v.11l.1-.015a4.416,4.416,0,0,1,3.518,1.157,5.32,5.32,0,0,1,1.838,4.038l0,.121.111,0a4.65,4.65,0,0,1,3.513,1.982,5.554,5.554,0,0,1,1.057,4.456l-.042.185.176-.018a5.479,5.479,0,0,1,4.719,2,6.574,6.574,0,0,1,1.23,5.621l-.028.113.1.054a11.663,11.663,0,0,1,4.154,3.259,5.163,5.163,0,0,1,.9,2.7,3.476,3.476,0,0,1-.833,2.544l-.109.114.119.1a11.027,11.027,0,0,1,3.484,4.253,5.01,5.01,0,0,1,.2,2.664,3.114,3.114,0,0,1-1.311,2.068l-.155.095.136.125a13.662,13.662,0,0,1,2.25,2.448,4.924,4.924,0,0,1,.875,3.042,2.572,2.572,0,0,1-1.484,2.353,1.844,1.844,0,0,1-2.321-.651l-.058-.1-.091.073a3.986,3.986,0,0,1-4.449.372,4.7,4.7,0,0,1-2.218-3.372l-.015-.108-.09.049a4.792,4.792,0,0,1-1.505.479,6.784,6.784,0,0,1-1.394.09,5.06,5.06,0,0,1-2.143-.489,2.109,2.109,0,0,1-1-.958c-.135-.3-.155-.48-.172-.475a.655.655,0,0,0,.024.127,1.38,1.38,0,0,0,.113.366,2.128,2.128,0,0,0,1.006,1.014",
    transform: "translate(-252.275 2219.744)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.06 15.481)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M303.137-2184.5a3.249,3.249,0,0,0,.342-.572,5.233,5.233,0,0,0,.5-1.887,5.156,5.156,0,0,0-.674-3.018,4.685,4.685,0,0,0-3.16-2.267l.072.116a7.048,7.048,0,0,0-.721-4.74,6.255,6.255,0,0,0-1.694-2.024,13.556,13.556,0,0,0-2.392-1.279,4.768,4.768,0,0,1-1.143-.767,3.266,3.266,0,0,1-.787-1.193c-.377-.925-.486-2.012-.965-3.01a5.264,5.264,0,0,0-5.324-2.993l.149.165a8.264,8.264,0,0,0-1.746-6.365,6.864,6.864,0,0,0-5.941-2.476l.144.161a7.061,7.061,0,0,0-3.187-6.751,5.934,5.934,0,0,0-6.359.275l.142.017a8.422,8.422,0,0,0-3.048-2.1,11.888,11.888,0,0,0-3.152-.849,13.649,13.649,0,0,0-5.234.286,10.046,10.046,0,0,0-3.128,1.342,6.081,6.081,0,0,0-.726.552c-.159.132-.235.207-.235.207.014.021.334-.268,1-.7a10.394,10.394,0,0,1,3.122-1.27,13.732,13.732,0,0,1,5.182-.227,11.848,11.848,0,0,1,3.1.859,8.258,8.258,0,0,1,2.962,2.062l.064.072.078-.054a5.723,5.723,0,0,1,6.119-.24,6.786,6.786,0,0,1,3.043,6.477l-.02.179.165-.018a6.619,6.619,0,0,1,5.715,2.385,7.968,7.968,0,0,1,1.684,6.125l-.028.191.177-.026a5.015,5.015,0,0,1,5.063,2.836c.456.933.569,2.013.966,2.989a3.524,3.524,0,0,0,.852,1.282,4.992,4.992,0,0,0,1.2.8,13.521,13.521,0,0,1,2.363,1.246,6.027,6.027,0,0,1,1.642,1.942,6.846,6.846,0,0,1,.729,4.583l-.02.1.093.017a4.54,4.54,0,0,1,3.07,2.159,5.066,5.066,0,0,1,.7,2.928,5.427,5.427,0,0,1-.446,1.87C303.255-2184.7,303.126-2184.512,303.137-2184.5Z",
    transform: "translate(-254.866 2226.191)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.635 15.7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M207.574-2183.4a1.007,1.007,0,0,0,.046-.784,1.881,1.881,0,0,0-.5-.8,2.928,2.928,0,0,0-1.08-.615,4.983,4.983,0,0,1-1.367-.65,2.989,2.989,0,0,1-.968-1.555,6.332,6.332,0,0,1-.188-2.2c.044-.79.171-1.625.185-2.52.046-1.816-.635-3.672-1.033-5.681a8.621,8.621,0,0,1-.07-3.15,3.864,3.864,0,0,1,1.642-2.664,12.518,12.518,0,0,1,3.108-1.081,5.132,5.132,0,0,0,1.593-.769,3.807,3.807,0,0,0,1.139-1.494,19.915,19.915,0,0,0,.987-3.752,6.7,6.7,0,0,1,.639-1.8,2.77,2.77,0,0,1,1.32-1.214,9.138,9.138,0,0,1,2.445-.317,3.559,3.559,0,0,0,1.241-.314,2.489,2.489,0,0,0,.989-.875,9.772,9.772,0,0,0,.961-2.43,6.024,6.024,0,0,1,1.141-2.14,5.145,5.145,0,0,1,3.871-1.923,5.226,5.226,0,0,1,3.72,1.541l.116.116.068-.154a8.593,8.593,0,0,1,5.313-4.812,7.144,7.144,0,0,1,2.951-.223,6.679,6.679,0,0,1,2.412.776,6.478,6.478,0,0,1,2.535,2.62,6.764,6.764,0,0,1,.424.909l.1.238a.412.412,0,0,0,.04.079.313.313,0,0,0-.023-.086l-.085-.246a5.931,5.931,0,0,0-.4-.932,6.465,6.465,0,0,0-2.534-2.71,6.769,6.769,0,0,0-2.453-.823,7.278,7.278,0,0,0-3.02.2,8.766,8.766,0,0,0-5.473,4.9l.183-.038a5.451,5.451,0,0,0-3.879-1.625,5.384,5.384,0,0,0-4.061,2,6.316,6.316,0,0,0-1.2,2.233,9.605,9.605,0,0,1-.927,2.354,2.516,2.516,0,0,1-2.041,1.071,9.2,9.2,0,0,0-2.514.333,3.04,3.04,0,0,0-1.454,1.334,6.987,6.987,0,0,0-.67,1.885,19.777,19.777,0,0,1-.963,3.7,3.527,3.527,0,0,1-1.054,1.391,4.895,4.895,0,0,1-1.513.733,12.549,12.549,0,0,0-3.164,1.117,3.55,3.55,0,0,0-1.175,1.235,5.127,5.127,0,0,0-.571,1.608,8.87,8.87,0,0,0,.083,3.25c.417,2.04,1.1,3.865,1.061,5.63-.007.875-.128,1.709-.165,2.511a6.468,6.468,0,0,0,.216,2.257,3.115,3.115,0,0,0,1.037,1.617,4.943,4.943,0,0,0,1.408.644,2.877,2.877,0,0,1,1.061.573,1.828,1.828,0,0,1,.5.757A1.262,1.262,0,0,1,207.574-2183.4Z",
    transform: "translate(-202.251 2225.913)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.073 8.692)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M187.567-2200.437a1.132,1.132,0,0,0,.094-.176l.251-.533.942-2.06c.413-.891.878-2.007,1.537-3.225a8.274,8.274,0,0,1,3.007-3.382c.72-.407,1.549-.669,2.382-1.053a5.444,5.444,0,0,0,1.216-.743,3.252,3.252,0,0,0,.919-1.232c.434-.987.464-2.113.814-3.135a2.7,2.7,0,0,1,.869-1.293,4.572,4.572,0,0,1,1.428-.687,8.612,8.612,0,0,0,1.569-.619,2.978,2.978,0,0,0,1.227-1.332,15.034,15.034,0,0,0,.812-3.7,4.85,4.85,0,0,1,.613-1.746,2.195,2.195,0,0,1,1.416-.974c1.164-.241,2.4.221,3.7.024a3.032,3.032,0,0,0,1.712-.945,8.739,8.739,0,0,0,1.124-1.628,18.384,18.384,0,0,1,.994-1.633,3.484,3.484,0,0,1,1.316-1.181,4.786,4.786,0,0,1,3.33.092,7.2,7.2,0,0,0,3.345.377,8.6,8.6,0,0,0,2.936-1.387,14.793,14.793,0,0,1,2.619-1.516,8.408,8.408,0,0,1,5.235-.087,9.549,9.549,0,0,1,3.842,2.24,11.674,11.674,0,0,1,2.1,2.788,13.953,13.953,0,0,1,.883,2.076l.2.558a1.143,1.143,0,0,0,.076.188,1.107,1.107,0,0,0-.05-.2l-.171-.569a12.832,12.832,0,0,0-.844-2.113,11.6,11.6,0,0,0-2.087-2.854,9.659,9.659,0,0,0-3.89-2.316,8.567,8.567,0,0,0-5.36.057,14.928,14.928,0,0,0-2.667,1.524,8.4,8.4,0,0,1-2.859,1.343,6.984,6.984,0,0,1-3.238-.384,10.384,10.384,0,0,0-1.712-.357,3.387,3.387,0,0,0-1.786.274,3.743,3.743,0,0,0-1.418,1.264,18.338,18.338,0,0,0-1.013,1.659,8.49,8.49,0,0,1-1.084,1.573,2.768,2.768,0,0,1-1.566.865c-1.205.194-2.444-.271-3.709-.02a2.46,2.46,0,0,0-1.579,1.091,5.132,5.132,0,0,0-.654,1.856,15.013,15.013,0,0,1-.781,3.628,2.7,2.7,0,0,1-1.117,1.219,8.535,8.535,0,0,1-1.525.606,4.732,4.732,0,0,0-1.5.73,2.966,2.966,0,0,0-.948,1.414c-.361,1.081-.387,2.2-.794,3.121a3.709,3.709,0,0,1-2.017,1.873c-.815.383-1.649.653-2.387,1.077a8.4,8.4,0,0,0-3.049,3.483c-.653,1.237-1.1,2.359-1.5,3.258l-.9,2.083-.227.545A1.221,1.221,0,0,0,187.567-2200.437Z",
    transform: "translate(-187.566 2234.814)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.636 33.188)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M198.611-2203.667a.619.619,0,0,0-.161-.034.925.925,0,0,0-.471.1,2.085,2.085,0,0,0-.9,1.68,5.5,5.5,0,0,0,.166,1.435,6.376,6.376,0,0,1,.2,1.662,3.878,3.878,0,0,1-.649,1.757c-.351.572-.8,1.13-1.159,1.81a2.955,2.955,0,0,0-.257,2.407c.268.82.8,1.512,1.057,2.346a3.847,3.847,0,0,1-.282,2.631c-.357.869-.861,1.708-1.213,2.674a4.641,4.641,0,0,0-.308,1.55,4.227,4.227,0,0,0,.309,1.592,18.855,18.855,0,0,0,1.635,2.76,4.668,4.668,0,0,1,.883,3.05,15.328,15.328,0,0,1-1.116,3.211,5.319,5.319,0,0,0-.356,1.754,4.235,4.235,0,0,0,.387,1.729,14.674,14.674,0,0,0,1.859,2.744,7.925,7.925,0,0,1,1.5,2.739,24.867,24.867,0,0,0,.868,3,3.439,3.439,0,0,0,.876,1.229,3.956,3.956,0,0,0,1.237.676,10.33,10.33,0,0,1,1.215.5,4.4,4.4,0,0,1,1.007.772,9.745,9.745,0,0,1,1.412,2.076c.394.72.759,1.429,1.172,2.065a6.121,6.121,0,0,0,3.033,2.511,6.01,6.01,0,0,0,2.876.353,5.449,5.449,0,0,0,1.766-.525,4.333,4.333,0,0,0,.559-.335,6.335,6.335,0,0,1-2.336.748,5.991,5.991,0,0,1-2.815-.394,6,6,0,0,1-2.928-2.475c-.4-.628-.757-1.334-1.148-2.062a9.974,9.974,0,0,0-1.437-2.135,4.593,4.593,0,0,0-1.06-.821,10.431,10.431,0,0,0-1.238-.514,3.755,3.755,0,0,1-1.164-.64,3.185,3.185,0,0,1-.8-1.139,25.087,25.087,0,0,1-.847-2.967,8.231,8.231,0,0,0-1.54-2.836,14.485,14.485,0,0,1-1.822-2.687,3.938,3.938,0,0,1-.359-1.6,5.046,5.046,0,0,1,.338-1.648,15.326,15.326,0,0,0,1.132-3.281,3.954,3.954,0,0,0-.189-1.741,7.253,7.253,0,0,0-.742-1.505,18.861,18.861,0,0,1-1.617-2.712,3.9,3.9,0,0,1-.292-1.477,4.346,4.346,0,0,1,.286-1.456c.335-.933.834-1.773,1.2-2.667a4.11,4.11,0,0,0,.278-2.811c-.283-.892-.821-1.577-1.075-2.347a2.72,2.72,0,0,1,.229-2.23c.342-.658.782-1.222,1.135-1.808a4.046,4.046,0,0,0,.656-1.849,6.442,6.442,0,0,0-.227-1.7,5.436,5.436,0,0,1-.187-1.4,2.052,2.052,0,0,1,.824-1.637A1.041,1.041,0,0,1,198.611-2203.667Z",
    transform: "translate(-194.633 2203.701)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.713 6.608)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M304.178-2187.218a3.016,3.016,0,0,0,.7-.061,4.6,4.6,0,0,0,1.871-.83,5.083,5.083,0,0,0,1.905-2.786,5.776,5.776,0,0,0-.643-4.535,13.228,13.228,0,0,0-1.731-2,6.426,6.426,0,0,1-1.612-2.308,4.557,4.557,0,0,1,.187-3.04c.355-1.021.888-2.012,1.231-3.142a10.286,10.286,0,0,0-.551-7.269,8.926,8.926,0,0,0-5.761-4.818l.076.226a4.992,4.992,0,0,0,.8-2.078,6.5,6.5,0,0,0-.093-2.281,6.864,6.864,0,0,0-.85-2.123,7.6,7.6,0,0,0-1.468-1.714,13.114,13.114,0,0,0-5.759-2.662,19.069,19.069,0,0,0-5.925-.4l.139.137a6.874,6.874,0,0,0-3.443-5.959,5.958,5.958,0,0,0-3.087-.709,9.631,9.631,0,0,0-2.907.772,5.429,5.429,0,0,1-1.365.313,3.308,3.308,0,0,1-1.326-.178,10.556,10.556,0,0,1-2.312-1.28,9.143,9.143,0,0,0-2.21-1.152,7.089,7.089,0,0,0-2.223-.368,6.961,6.961,0,0,0-3.681,1.011,7.838,7.838,0,0,0-2.179,1.979,8.037,8.037,0,0,0-.955,1.629,4.562,4.562,0,0,0-.231.619c.012.006.085-.209.271-.6a8.527,8.527,0,0,1,.982-1.59,7.83,7.83,0,0,1,2.174-1.919,6.861,6.861,0,0,1,3.618-.955,7,7,0,0,1,2.171.377,9.039,9.039,0,0,1,2.163,1.147,10.7,10.7,0,0,0,2.352,1.315,3.493,3.493,0,0,0,1.4.194,5.611,5.611,0,0,0,1.418-.317,9.506,9.506,0,0,1,2.851-.749,5.747,5.747,0,0,1,2.969.694,6.61,6.61,0,0,1,3.293,5.727l0,.15.138-.012a18.887,18.887,0,0,1,5.85.4,12.9,12.9,0,0,1,5.644,2.606,7.329,7.329,0,0,1,1.413,1.649,6.588,6.588,0,0,1,.813,2.028,6.191,6.191,0,0,1,.091,2.168,4.7,4.7,0,0,1-.747,1.95l-.121.178.2.048a8.676,8.676,0,0,1,5.6,4.665,10.016,10.016,0,0,1,.554,7.066c-.328,1.1-.855,2.091-1.216,3.135a4.8,4.8,0,0,0-.175,3.2,6.607,6.607,0,0,0,1.674,2.381,12.991,12.991,0,0,1,1.719,1.96,5.615,5.615,0,0,1,.656,4.388,5.016,5.016,0,0,1-1.828,2.743,4.746,4.746,0,0,1-1.828.862C304.42-2187.233,304.177-2187.234,304.178-2187.218Z",
    transform: "translate(-260.776 2237.461)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.614)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M195.877-2219.274a.938.938,0,0,0,.028-.183c.014-.136.033-.313.056-.537.05-.49.12-1.182.21-2.064s.236-1.988.48-3.238a19.619,19.619,0,0,1,1.235-4.109,12.241,12.241,0,0,1,2.879-4.141,8.249,8.249,0,0,1,2.286-1.47,22.672,22.672,0,0,1,2.756-.8,7.673,7.673,0,0,0,2.8-1.285,13.146,13.146,0,0,0,2.288-2.384c.7-.883,1.365-1.815,2.138-2.656a9.048,9.048,0,0,1,2.682-2.071,14.827,14.827,0,0,1,6.4-1.348,38.382,38.382,0,0,1,6.128.39,29.637,29.637,0,0,1,9.92,3.217,22.442,22.442,0,0,1,5.685,4.4c.288.323.555.6.768.856l.522.668.326.408a.793.793,0,0,0,.119.133.932.932,0,0,0-.1-.151l-.305-.427-.5-.689c-.208-.264-.47-.548-.754-.878a21.947,21.947,0,0,0-5.673-4.506,29.458,29.458,0,0,0-9.973-3.3,38.077,38.077,0,0,0-6.167-.41,15.007,15.007,0,0,0-6.5,1.37,9.287,9.287,0,0,0-2.758,2.13c-.788.858-1.456,1.8-2.149,2.675a12.909,12.909,0,0,1-2.235,2.342,7.432,7.432,0,0,1-2.717,1.253,22.471,22.471,0,0,0-2.78.826,8.448,8.448,0,0,0-2.345,1.524,12.409,12.409,0,0,0-2.908,4.238,19.574,19.574,0,0,0-1.21,4.163c-.231,1.261-.351,2.361-.436,3.259s-.131,1.6-.161,2.072c-.013.224-.022.4-.03.539A.971.971,0,0,0,195.877-2219.274Z",
    transform: "translate(-195.874 2245.854)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.37 63.293)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M243.258-2162.183a3.588,3.588,0,0,0-1.912-3.037,2.75,2.75,0,0,0-3.26.764,3.033,3.033,0,0,0-.164,3.4,2.948,2.948,0,0,0,1.256,1.2,3.351,3.351,0,0,0,2.136.246,2.411,2.411,0,0,0,1.542-.91A2.67,2.67,0,0,0,243.258-2162.183Z",
    transform: "translate(-237.478 2165.464)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.002 61.916)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M241.77-2167.213c-.331.009-.153,2.4-1.911,4.274s-4.127,1.818-4.119,2.154c-.019.153.559.418,1.554.358a5.305,5.305,0,0,0,3.448-1.663,5.438,5.438,0,0,0,1.461-3.571C242.212-2166.67,241.921-2167.241,241.77-2167.213Z",
    transform: "translate(-235.74 2167.214)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.395 220.361)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M304.329-1964.576c-.21-.894-.34-1.4-.34-1.4-.3.108-2.929.641-6.784,1.4Z",
    transform: "translate(-297.205 1965.971)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.578 95.064)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.431)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M267.609-2122.27c-.768-.536-10.979-2.842-10.979-2.842l-24.62.7-8.818,1.767s-1.634,29.706-1.389,30.243,11.632,10.729,12.114,11.265,24-8.046,24-8.046l15.513-30.222Z",
    transform: "translate(-221.778 2125.112)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.188 13.578)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M319.05-2044.746l22.148,7.462a19.06,19.06,0,0,0,.413-14.7c-3.008-8.44-37.967-55.879-37.967-55.879s-13.006,11.56-12.29,24.966l5.482,14.874Z",
    transform: "translate(-291.326 2107.866)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.379)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M197.729-2029.883c-2.656,6.74-8.21,23.813-10.791,31.836h94.227c-2.866-15.032-10.054-40.751-10.054-40.751l4.385-29.9,25.629-17.271s-14.57-22.541-20.493-28c-5.59-5.153-22.08-9.113-23.315-9.113,0,0-13.06,22.7-26.3,20.337-12.911-2.3-9.816-20.619-9.816-20.619l-16.125,2.431-10.88,20.063s-3.052,23-3.108,34.609C191.046-2059.039,198.42-2031.637,197.729-2029.883Z",
    transform: "translate(-186.938 2123.36)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.562 73.2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.453)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M308.467-1981.451c14.289-11.491,35.554-39.347,35.116-39.729s-20.327-10.96-20.327-10.96l-20.718,39.8.792,8.006Z",
    transform: "translate(-302.538 2032.14)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 28.308)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M268.628-1984.83l-1.841.47c-.275.8.8,2.086,1.638,2.244s9.761-.314,9.761-.314l6.31,1.769-3.561-.225-9.36,1.99.088.886c.779,3.112,10.305,1.616,10.305,1.616l2.537.6s10.5,4.8,12.394,4.83,4.585-3.738,4.585-3.738l-5.144-11.442a6.316,6.316,0,0,1-2.449.287c-1.542-.076-3.774-2.378-3.774-2.378a35.269,35.269,0,0,1-3.071-3.613s-6.5-3.726-7.382-4.263-9.593,2.016-9.593,2.016c-.745,2.009,4.575,4.161,4.575,4.161l-8.246,2.424C266.465-1986.107,268.628-1984.83,268.628-1984.83Z",
    transform: "translate(-266.399 1996.186)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.25 8.128)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M270.787-1983.479c1.731-.488,4.137-1.107,6.8-1.749a8.065,8.065,0,0,1,.968-.2,2.774,2.774,0,0,1,.917.069c.594.178,1.2.4,1.752.6,1.116.413,2.108.828,2.927,1.212a20.116,20.116,0,0,1,1.894,1,4.24,4.24,0,0,0,.683.4,2.377,2.377,0,0,0-.6-.544,13.826,13.826,0,0,0-1.86-1.136,30.52,30.52,0,0,0-2.922-1.307c-.567-.217-1.137-.44-1.784-.64a3.065,3.065,0,0,0-1.036-.085,7.92,7.92,0,0,0-1.02.209c-2.671.644-5.074,1.31-6.793,1.875-.859.282-1.549.535-2.016.736a2.612,2.612,0,0,0-.709.362,3.239,3.239,0,0,0,.757-.206C269.223-1983.027,269.921-1983.235,270.787-1983.479Z",
    transform: "translate(-267.987 1985.862)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.04 5.091)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M282.778-1989.2a9.717,9.717,0,0,1,4.12,1.746c.953.695,1.45,1.267,1.5,1.217a5.021,5.021,0,0,0-1.338-1.46,8.974,8.974,0,0,0-4.223-1.92,8.64,8.64,0,0,0-4.554.514,4.692,4.692,0,0,0-1.669.977c.032.063.66-.328,1.757-.694A9.4,9.4,0,0,1,282.778-1989.2Z",
    transform: "translate(-276.611 1989.719)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.738 88.683)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M221.061-2003.013c2.427-.711,5.748-1.821,9.35-3.262s6.788-2.942,9.057-4.114a21.189,21.189,0,0,0,3.593-2.076,27.62,27.62,0,0,0-3.783,1.612l-18.35,7.353a27.276,27.276,0,0,0-3.84,1.443A20.15,20.15,0,0,0,221.061-2003.013Z",
    transform: "translate(-217.088 2012.474)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.008 98.617)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M180.722-2070.117l-10.757-38.792s32.168-13.864,33.936-11.4l-10.181,47.08Z",
    transform: "translate(-169.965 2120.599)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.219 123.476)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M198.363-2089.025a8.668,8.668,0,0,1-.471,1.663c-.335,1.055-.833,2.576-1.384,4.477a108.7,108.7,0,0,0-3.358,15.1,75.1,75.1,0,0,0-.716,8.5c.017,1.31-.03,2.56.071,3.722q.05.869.1,1.685.1.8.187,1.542c.5,3.934,1.383,6.236,1.246,6.288a8.4,8.4,0,0,1-.627-1.6,13.21,13.21,0,0,1-.555-1.956,22.32,22.32,0,0,1-.526-2.652l-.233-1.559q-.066-.825-.136-1.7c-.125-1.179-.1-2.443-.133-3.772a68.24,68.24,0,0,1,.671-8.6,91.02,91.02,0,0,1,3.569-15.155c.611-1.89,1.178-3.39,1.587-4.417A8.325,8.325,0,0,1,198.363-2089.025Z",
    transform: "translate(-191.825 2089.025)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(111.011 139.12)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "M206.525-2054.713c.354,1.854.724,3.62,1.087,5.3,2.964,13.4,5.8,20.95,6.288,20.785.59-.186-1.229-8.029-3.332-21.434q-.368-2.519-.773-5.286-.185-1.385-.381-2.831c-.064-.591-.171-1.288-.231-1.854.064.079.129.151.188.237l.433.626c1.2,1.728,2.405,3.548,3.629,5.431a200.3,200.3,0,0,1,14.279,26.291,2.461,2.461,0,0,0,1.757,1.428,2.435,2.435,0,0,0,2.779-2.135l0-.023c.87-5.515.637-11.186.411-16.722a70.49,70.49,0,0,1,.368-13.227A158.342,158.342,0,0,1,238.506-2036l.009.052a2.564,2.564,0,0,0,.947,1.6,3.229,3.229,0,0,0,1.579.654,3.246,3.246,0,0,0,1.487-.195,4.542,4.542,0,0,0,1.64-1.126,6.73,6.73,0,0,0,.949-1.273l.5-.938a39.477,39.477,0,0,0,1.76-3.756c1.038-2.5,1.86-4.95,2.675-7.274,1.6-4.643,3.25-8.842,5.736-11.83a17.217,17.217,0,0,1,1.785-1.856c.017.08.039.152.05.236a10.853,10.853,0,0,1,.064,1.3c.035.988.032,1.964.02,2.926-.045,3.843-.349,7.443-.581,10.73a98.818,98.818,0,0,0-.346,15.572c.313,3.645.894,5.54,1.138,5.5.3-.044.259-1.991.446-5.527.158-3.547.772-8.653,1.708-15.179.439-3.27.949-6.9,1.185-10.943.059-1.01.108-2.041.117-3.1a14.115,14.115,0,0,0-.028-1.79,6.671,6.671,0,0,0-.586-2.235,4.014,4.014,0,0,0-.934-1.268,3.033,3.033,0,0,0-1.694-.76,3.774,3.774,0,0,0-2.716.917,21.842,21.842,0,0,0-2.6,2.464c-3.244,3.646-5.181,8.412-6.93,13.055-.882,2.336-1.734,4.685-2.724,6.935-.231.527-.506,1.02-.755,1.535a152.189,152.189,0,0,0-7.216-25.8l-.05-.131a2.591,2.591,0,0,0-1.241-1.407,2.392,2.392,0,0,0-3.285,1.3l-1.026,2.391c-.272.844-.563,1.7-.818,2.572-1.662,6.281-1.328,12.4-1.115,17.98.113,2.274.2,4.47.241,6.616a179.378,179.378,0,0,0-11.144-18.326c-1.316-1.88-2.611-3.689-3.91-5.4l-.5-.661a7.981,7.981,0,0,0-.68-.777,5.219,5.219,0,0,0-1.972-1.307,3.009,3.009,0,0,0-3.212.836,4.119,4.119,0,0,0-.956,2.8,23.156,23.156,0,0,0,.461,3.323Q206.265-2056.107,206.525-2054.713Zm50.878-7.766h0C257.37-2062.515,257.357-2062.533,257.4-2062.479Z",
    transform: "translate(-205.532 2069.156)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(344.443 33.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.664 181.505)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M655.512-2021.212l-2.878-.943-33.882-11.105L603.2-2011.9l56.169,11.209Z",
    transform: "translate(-603.2 2033.261)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.976 189.472)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M701.744-2013.423l-6.119-3.752,1.665-2.75a2.118,2.118,0,0,0-2.1-3.2l-15.509,2.105-10.042,1.956.194,19.823,32.437,12.358a2.454,2.454,0,0,0,2.62-.568A16.7,16.7,0,0,0,701.744-2013.423Z",
    transform: "translate(-669.642 2023.142)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.935)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.51 18.035)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M605.117-2221.891a9.782,9.782,0,0,0,4.631-8.581,9.816,9.816,0,0,0-5.332-8.178l-11.745-2.237q.469,21.721.638,43.446c3-.552,6.06-1.456,8.311-3.481s3.462-5.423,2.151-8.132a7.771,7.771,0,0,0,4.281-6.053A7.705,7.705,0,0,0,605.117-2221.891Z",
    transform: "translate(-592.672 2240.887)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.439 23.813)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M536.962-2221.462l-.265-5.135,31.2-6.828c9.646-1.3,20.411,7.916,21.324,17.448,1.014,10.59,1.828,23.558.8,31.514-2.068,16-14.412,18.4-14.412,18.4l1,15.718c.4,9.184-7.406,11.448-16.745,11.849h0a16.842,16.842,0,0,1-17.628-15.37Z",
    transform: "translate(-536.697 2233.548)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.104 22.412)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.967 6.442)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M596.811-2195.116a2.056,2.056,0,0,1-1.937,2.121,1.977,1.977,0,0,1-2.2-1.776,2.056,2.056,0,0,1,1.934-2.122A1.979,1.979,0,0,1,596.811-2195.116Z",
    transform: "translate(-592.672 2196.9)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M597.113-2203.056c-.249.274-1.858-.823-4.093-.749-2.232.042-3.836,1.223-4.087.96-.123-.115.124-.6.822-1.136a5.763,5.763,0,0,1,3.262-1.1,5.535,5.535,0,0,1,3.267.928C596.988-2203.654,597.236-2203.18,597.113-2203.056Z",
    transform: "translate(-588.904 2205.082)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.156 23.493)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.887 5.688)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M570.1-2194.7a2.055,2.055,0,0,1-1.937,2.121,1.977,1.977,0,0,1-2.2-1.775,2.057,2.057,0,0,1,1.935-2.123A1.979,1.979,0,0,1,570.1-2194.7Z",
    transform: "translate(-565.964 2196.485)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M569.237-2201.685c-.25.274-1.861-.822-4.093-.749-2.232.043-3.837,1.223-4.088.962-.122-.116.122-.6.823-1.137a5.753,5.753,0,0,1,3.261-1.1,5.539,5.539,0,0,1,3.268.928C569.11-2202.282,569.359-2201.808,569.237-2201.685Z",
    transform: "translate(-561.027 2203.709)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.366 23.288)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M581.968-2185.7a15.05,15.05,0,0,1,3.608-.754c.568-.075,1.1-.2,1.189-.589a2.817,2.817,0,0,0-.433-1.651l-1.822-4.22c-2.535-6.01-4.389-10.96-4.142-11.058s2.5,4.693,5.037,10.7q.916,2.223,1.751,4.248a3.2,3.2,0,0,1,.366,2.193,1.422,1.422,0,0,1-.912.849,3.9,3.9,0,0,1-.964.162A14.7,14.7,0,0,1,581.968-2185.7Z",
    transform: "translate(-580.346 2203.969)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.491 62.487)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M580.057-2149.141a43.509,43.509,0,0,1-22.414-5.041s5.981,11.215,22.689,9.246Z",
    transform: "translate(-557.643 2154.182)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.588 45.487)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M579.629-2174.375a4.065,4.065,0,0,0-3.656-1.36,3.692,3.692,0,0,0-2.5,1.417,2.261,2.261,0,0,0-.094,2.624,2.737,2.737,0,0,0,2.952.639,8.49,8.49,0,0,0,2.8-1.764,2.44,2.44,0,0,0,.618-.669.727.727,0,0,0-.029-.817",
    transform: "translate(-573.007 2175.774)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.133 43.282)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M574.027-2178.574c.362-.031.443,2.353,2.571,3.982s4.7,1.288,4.731,1.621c.039.148-.561.48-1.65.542a6.11,6.11,0,0,1-3.946-1.218,5.155,5.155,0,0,1-2-3.343C573.609-2177.984,573.861-2178.583,574.027-2178.574Z",
    transform: "translate(-573.7 2178.574)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M591.363-2236.835a9.807,9.807,0,0,0,3.592-10.329,11.392,11.392,0,0,0-8.05-7.75,12.217,12.217,0,0,0-2.359-.361,10.553,10.553,0,0,0-5.076-1.262,5.4,5.4,0,0,0-4.271-4.052,13.192,13.192,0,0,0-6.222.428,10.826,10.826,0,0,0-8.814-3.6,10.766,10.766,0,0,0-8.169,4.855,8.923,8.923,0,0,0-7.747-.3,8.676,8.676,0,0,0-4.88,5.926,8.666,8.666,0,0,0-6.085,3.041,8.274,8.274,0,0,0-1.326,2.232,8,8,0,0,0-1.435,3.193,9.925,9.925,0,0,0-8.15,7.459,9.753,9.753,0,0,0,4.3,10.1,8.792,8.792,0,0,0-2.337,7.5,8.9,8.9,0,0,0,4.714,6.325,11.025,11.025,0,0,0,1.15,8.735,5.492,5.492,0,0,0,2.932,2.521,2.114,2.114,0,0,0,.268.59c1.013,1.461,3.377.741,4.749-.4,3.336-2.779,5.041-7.033,5.881-11.253s.941-8.553,1.739-12.78c.017-.094.036-.194.056-.3a11.594,11.594,0,0,1,2.171-4.835,31.154,31.154,0,0,0,3.957,2.331,13.051,13.051,0,0,0,14.9-3.384,19.138,19.138,0,0,0,12.163,3.952c4.356-.126,8.641-1.057,11.9-3.905a5.959,5.959,0,0,0,1.812-2.734C592.951-2235.685,592.159-2236.625,591.363-2236.835Z",
    transform: "translate(-522.168 2263.793)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.043 56.323)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M538.776-2191.711c-.216-.1-8.794-3.009-8.932,5.731s8.816,7.073,8.836,6.821S538.776-2191.711,538.776-2191.711Z",
    transform: "translate(-529.843 2192.257)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.298 59.128)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M536.626-2181.752c-.039-.029-.157.1-.42.218a1.569,1.569,0,0,1-1.157.006c-.934-.353-1.7-1.831-1.72-3.407a4.962,4.962,0,0,1,.467-2.173,1.776,1.776,0,0,1,1.183-1.151.793.793,0,0,1,.908.431c.115.246.056.419.1.435.025.022.193-.143.128-.505a.973.973,0,0,0-.342-.553,1.183,1.183,0,0,0-.853-.235,2.169,2.169,0,0,0-1.638,1.331,5.093,5.093,0,0,0-.575,2.428c.03,1.762.92,3.424,2.2,3.808a1.678,1.678,0,0,0,1.419-.21C536.606-2181.542,536.656-2181.737,536.626-2181.752Z",
    transform: "translate(-532.707 2188.693)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.716 15.2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M601.407-2244.487a.759.759,0,0,1,.083.206,4.732,4.732,0,0,1,.163.627,6.421,6.421,0,0,1-.008,2.468,6.51,6.51,0,0,1-1.822,3.423,7.047,7.047,0,0,1-4.706,2.011l.157-.138a14.9,14.9,0,0,1-3.56,7.65,11.775,11.775,0,0,1-3.86,2.957,9.937,9.937,0,0,1-5.1.821,17.622,17.622,0,0,1-4.951-1.146,13.462,13.462,0,0,1-4.14-2.368l.268,0a16.174,16.174,0,0,1-7.38,4.183,12.863,12.863,0,0,1-6.691-.453,13.205,13.205,0,0,1-3.87-2.068,10.776,10.776,0,0,1-.887-.76,1.857,1.857,0,0,1-.278-.291c.022-.024.421.356,1.242.949a13.835,13.835,0,0,0,3.868,1.946,12.759,12.759,0,0,0,6.542.362,15.966,15.966,0,0,0,7.183-4.137l.13-.125.138.121a13.2,13.2,0,0,0,4.019,2.275,17.336,17.336,0,0,0,4.837,1.116,9.559,9.559,0,0,0,4.9-.781,11.452,11.452,0,0,0,3.741-2.849,14.689,14.689,0,0,0,3.527-7.445l.021-.135.137,0a6.8,6.8,0,0,0,4.53-1.875,6.4,6.4,0,0,0,1.824-3.276,6.762,6.762,0,0,0,.094-2.418C601.476-2244.195,601.385-2244.481,601.407-2244.487Z",
    transform: "translate(-554.829 2244.487)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.165 18.472)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M533.7-2240.331a18.346,18.346,0,0,0-.759,3,12.3,12.3,0,0,0,1.481,7.766l.072.125-.11.1a8.03,8.03,0,0,0-2.337,3.564,7.593,7.593,0,0,0-.029,4.65,8.107,8.107,0,0,0,3.818,4.616l.164.086-.083.166a9.893,9.893,0,0,0-1,5.458,10.7,10.7,0,0,0,1.31,4.228,12.271,12.271,0,0,0,2.542,3.081.926.926,0,0,1-.233-.149,7.3,7.3,0,0,1-.629-.5,9.674,9.674,0,0,1-1.89-2.32,10.677,10.677,0,0,1-1.427-4.311,10.1,10.1,0,0,1,.979-5.662l.08.252a8.428,8.428,0,0,1-4.02-4.83,7.925,7.925,0,0,1,.04-4.887,8.326,8.326,0,0,1,2.475-3.714l-.039.221a12.221,12.221,0,0,1-1.379-7.972,11.174,11.174,0,0,1,.616-2.23c.1-.25.192-.433.25-.559S533.694-2240.334,533.7-2240.331Z",
    transform: "translate(-531.268 2240.331)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.697 68.188)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M534.942-2176.247a6.907,6.907,0,0,0-.172,1.569,2.332,2.332,0,0,0,.646,1.474,1.979,1.979,0,0,0,1.824.5,1.6,1.6,0,0,0,1.105-1.442,2.994,2.994,0,0,0-.312-1.616c-.432-.879-.82-1.388-.759-1.427a4.153,4.153,0,0,1,1.015,1.3,3.1,3.1,0,0,1,.427,1.778,2.24,2.24,0,0,1-.361,1.063,1.777,1.777,0,0,1-1.007.726,2.312,2.312,0,0,1-2.2-.63,2.513,2.513,0,0,1-.666-1.717A2.316,2.316,0,0,1,534.942-2176.247Z",
    transform: "translate(-534.484 2177.186)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 97.435)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M542.135-2034.2l-3.268,29.128,39.605,3.837h25.937c-.421-6.653-1.641-15.233-1.641-15.233l.419-12.815-6.793-55.378a136.03,136.03,0,0,1-.1-24.88c1.176-14.456-8.82-16.384-11.76-17.925s-15.561-6.881-15.561-6.881l-30.263-5.693-6.842,4.916-13.432,11.855,19.748,48.7Z",
    transform: "translate(-518.44 2140.04)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.432)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M564.448-2099.93c4.211,19.408-22.632,25.361-22.632,25.361l7.6,73.334h57.039l.362-45.645s6.053-12.421,6.579-22.773-3.684-14.75-6.316-19.407-24.319-41.482-24.319-41.482l-7.027-2.633s5.123,9.838.306,12.519c-3.709,2.063-15.577-6.7-15.577-6.7-11.615-9.965-18.12-12.685-18.12-12.685l-6.842,4.916C545.764-2136.676,560.237-2119.338,564.448-2099.93Z",
    transform: "translate(-535.5 2140.04)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.128 56.971)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M584.649-2045.037a5.661,5.661,0,0,0,1.489.283,19.059,19.059,0,0,0,4.14-.008,21.422,21.422,0,0,0,12.268-5.566,20.774,20.774,0,0,0,6.193-11.812,18.128,18.128,0,0,0,.188-4.067,5.363,5.363,0,0,0-.222-1.475,36.412,36.412,0,0,1-.429,5.464,21.278,21.278,0,0,1-6.189,11.417,21.921,21.921,0,0,1-11.867,5.58A38.282,38.282,0,0,1,584.649-2045.037Z",
    transform: "translate(-584.649 2067.681)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(53.795 58.799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.441-2050c4.614-3.482,6.213-9.427,6.7-15.362,1.492,6.044.024,13.451-4.66,17.632a18.314,18.314,0,0,1-17.716,3.552C592.532-2044.922,597.827-2046.516,602.441-2050Z",
    transform: "translate(-586.766 2065.359)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.063 221.005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M595.682-1973.571c-20.914-1.716-39.781-4.286-52.278-9.52a139.716,139.716,0,0,0-9.643,15.054h61.576C595.544-1971.48,595.682-1973.571,595.682-1973.571Z",
    transform: "translate(-533.761 1983.091)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.051 8.525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.05-1972.263l-17.55,1.217-2.089,5.311h21.995C622.918-1969.868,622.05-1972.263,622.05-1972.263Z",
    transform: "translate(-602.412 1972.263)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.441 5.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.429-1975.4c1.613.623,3.985,1.43,6.943,2.338s6.522,1.868,10.517,2.776c4,.877,8.436,1.7,13.127,2.317,4.7.6,9.2.942,13.292,1.117,4.1.143,7.793.138,10.89.006s5.6-.294,7.322-.484l1.982-.22a2.76,2.76,0,0,0,.687-.121,2.848,2.848,0,0,0-.7-.01l-1.99.1c-1.725.112-4.226.214-7.316.276s-6.77.029-10.85-.146c-4.078-.208-8.556-.567-13.231-1.163-4.67-.62-9.088-1.416-13.082-2.257-3.985-.873-7.551-1.771-10.516-2.631s-5.355-1.587-6.991-2.136l-1.9-.6a2.8,2.8,0,0,0-.677-.168,2.824,2.824,0,0,0,.631.291Z",
    transform: "translate(-541.942 1976.411)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(151.225 181.038)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M714.809-2026.9l-10.883-6.954-9.837,43.665,6.7,8.591S714.66-2025.929,714.809-2026.9Z",
    transform: "translate(-694.09 2033.854)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(142.958 189.459)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M687.7-2011.921c7.548,2.112,12.794-4.089,12.794-4.089s.064,2.3,3.607,5.13,5.37,1.246,5.37,1.246l-5.379-10.953a4.6,4.6,0,0,0-4.973-2.493l-13.812,2.58S680.153-2014.033,687.7-2011.921Z",
    transform: "translate(-683.59 2023.159)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(159.219 214.491)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M705.741-1985.852c.433-3,.539-5.469.239-5.512s-.894,2.354-1.327,5.355-.539,5.469-.239,5.512S705.309-1982.852,705.741-1985.852Z",
    transform: "translate(-704.244 1991.365)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(156.271 211.583)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M702.037-1986.273c.338-4.847.091-8.787-.206-8.786s-.557,3.905-.892,8.71-.617,8.707-.309,8.749S701.707-1981.427,702.037-1986.273Z",
    transform: "translate(-700.499 1995.059)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(2.508 197.789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511.386-1974.129H553.5c24.34-7.226,71.131-27.605,71.446-28.746l-2.774-9.7L537-1994.942l-31.733-13.695s-.709,22.531,2.738,30.738A8.067,8.067,0,0,0,511.386-1974.129Z",
    transform: "translate(-505.203 2012.578)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 105.827)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.253)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M510.837-2010.129c3.283,2.68,15.116,7.44,25.037,5.059s69.7-23.018,69.7-23.018l-4.548-14.882-66.9,6.717,6.7-56.247-14.864-36.881c-5.984,1.969-16.015,12.06-19.318,22.42s-5.359,40.539-3.745,59.99S507.555-2012.809,510.837-2010.129Z",
    transform: "translate(-502.338 2129.381)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 22.089)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M503.685-2029.851a153.082,153.082,0,0,0,2.593,15.4,44.425,44.425,0,0,0,2.441,7.783,12.313,12.313,0,0,0,1.048,1.842,5.585,5.585,0,0,0,.731.831,10.742,10.742,0,0,0,.863.65,24.3,24.3,0,0,0,3.782,1.984,40.061,40.061,0,0,0,8.259,2.543,32.828,32.828,0,0,0,8.81.594,41.608,41.608,0,0,0,8.743-2.005c2.871-.872,5.75-1.786,8.646-2.719q8.687-2.806,17.578-5.792c13.253-4.438,26.128-8.832,38.436-13.077l.292-.1-.089-.291q-2.325-7.595-4.556-14.881l-.075-.245-.26.026-66.6,6.758c2.007-17.223,3.633-31.181,4.762-40.867.55-4.849.977-8.619,1.269-11.2q.2-1.9.313-2.915c.066-.657.083-1,.083-1s-.064.333-.154.988q-.132,1.013-.38,2.907c-.323,2.578-.794,6.343-1.4,11.186-1.186,9.736-2.9,23.787-5.011,41.137l-.035.294.3-.03,66.653-6.618,4.376,14.347c-12.222,4.2-25,8.557-38.144,12.959l-17.569,5.792c-2.894.935-5.771,1.849-8.634,2.72a41.092,41.092,0,0,1-8.6,1.985,32.139,32.139,0,0,1-8.633-.577,39.436,39.436,0,0,1-8.129-2.493,23.648,23.648,0,0,1-3.684-1.925,6.469,6.469,0,0,1-2.428-3.067,44.012,44.012,0,0,1-2.413-7.663,153.665,153.665,0,0,1-2.609-15.333c-.616-5.007-1.112-9.892-1.4-14.615a254.156,254.156,0,0,1,.031-26.345c.413-8.049,1.074-15.32,2.046-21.648a62.78,62.78,0,0,1,1.879-8.7l-.3-.094a62.507,62.507,0,0,0-1.943,8.741,215.1,215.1,0,0,0-2.149,21.68,251.8,251.8,0,0,0-.112,26.4C502.592-2039.759,503.077-2034.876,503.685-2029.851Z",
    transform: "translate(-502.017 2101.326)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.679 93.078)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M534.322-2004.6c2.913-3.852,5.951-6.4,5.814-6.552a8.447,8.447,0,0,0-2.09,1.557,32.674,32.674,0,0,0-4.256,4.6,32.388,32.388,0,0,0-3.3,5.31,8.133,8.133,0,0,0-.931,2.41C529.75-1997.19,531.382-2000.774,534.322-2004.6Z",
    transform: "translate(-529.551 2011.161)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.581 93.121)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M540.422-2011.063c-.024-.165-2.217.111-4.622,1.309s-3.946,2.748-3.826,2.866c.128.147,1.8-1.146,4.124-2.281C538.412-2010.325,540.466-2010.875,540.422-2011.063Z",
    transform: "translate(-531.968 2011.106)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.035 78.068)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M632.47-2007.176c3.569.619,19.485-2.055,19.485-2.055l2.275,1.068,1.268,2.9s-2.694.805-3.355,2.609a5.22,5.22,0,0,0,.17,3.6l7.217-3.877.923-6.542a7.185,7.185,0,0,0,.339-5.126,4.054,4.054,0,0,0,.7-1.89c.026-.938-6.582-6.366-6.582-6.366l5.2-.093s3.219.454,6.1,1.171,3.931-3.227,3.931-3.227l-13.8-4.787s-9.458,0-11.543-.135-19.541,8.294-19.541,8.294l2.119,16.078Z",
    transform: "translate(-625.263 2029.923)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M627.423-2022.626l6.061-2.734c2.621-1.145,5.793-2.611,9.538-3.945a10.034,10.034,0,0,1,1.421-.4,9.235,9.235,0,0,1,1.523-.027l3.289.052,7.041.1,13.433,4.694a5.534,5.534,0,0,1-1.192,2.067,2.3,2.3,0,0,1-2.392.629c-1.945-.474-3.937-.839-5.979-1.146l-.025,0h-.028l-5.2.091-.87.016.663.561q1.107.94,2.23,1.89c1.072.936,2.133,1.875,3.1,2.852.244.242.475.492.69.742a3.58,3.58,0,0,1,.292.376l.117.18c0,.037.024.033.033.09a3.566,3.566,0,0,1-.64,1.689l-.09.136.049.158a6.846,6.846,0,0,1-.322,4.879l-.021.045-.007.05c-.308,2.2-.609,4.363-.893,6.389l-6.748,3.641a4.458,4.458,0,0,1,.083-3.41,5.488,5.488,0,0,1,3-2.109l.293-.1-.118-.268c-.446-1.009-.883-2-1.278-2.9l-.04-.091-.09-.042-2.28-1.06-.074-.035-.08.013c-4.232.711-8.039,1.275-11.314,1.682a42.336,42.336,0,0,1-8.1.5l-.038,0-.024.009-3.769,1.268-.962.342a1.327,1.327,0,0,0-.318.137,1.5,1.5,0,0,0,.339-.073l.982-.281,3.785-1.146a40.6,40.6,0,0,0,8.156-.361c3.267-.364,7.056-.886,11.271-1.559l2.109,1,1.108,2.558a5.712,5.712,0,0,0-3.066,2.245,5.112,5.112,0,0,0-.027,4.239l.118.3.3-.16,7.225-3.863.139-.075.023-.156c.294-2.061.607-4.267.928-6.517a7.438,7.438,0,0,0,.364-5.144,4.016,4.016,0,0,0,.687-1.9,1.419,1.419,0,0,0-.1-.4c-.052-.094-.1-.168-.158-.252a4.009,4.009,0,0,0-.338-.438c-.234-.272-.473-.531-.724-.78-.993-1-2.057-1.946-3.138-2.888l-1.582-1.341,4.305-.078c2.007.3,3.988.659,5.894,1.119a3.108,3.108,0,0,0,1.629.026,3.185,3.185,0,0,0,1.378-.832,6.358,6.358,0,0,0,1.457-2.615l.085-.275-.287-.1-13.808-4.757-.045-.016h-.05l-7.072-.058-3.28-.025a10.3,10.3,0,0,0-1.618.046,9.92,9.92,0,0,0-1.507.432c-3.778,1.389-6.917,2.89-9.525,4.082-2.6,1.21-4.623,2.194-6,2.874l-1.562.791a3.132,3.132,0,0,0-.521.3,3.2,3.2,0,0,0,.561-.22Z",
    transform: "translate(-625.263 2030.226)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124.455 93.048)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M663.958-2008.441c2.081,1.556,3.55,3.082,3.7,2.956.137-.1-1.147-1.867-3.294-3.475s-4.206-2.376-4.271-2.219C660.007-2011.006,661.889-2010.01,663.958-2008.441Z",
    transform: "translate(-660.089 2011.2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(123.782 87.783)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M663.452-2014.9c2.311,1.634,4.055,3.137,4.189,3,.125-.119-1.442-1.864-3.8-3.531s-4.528-2.591-4.6-2.437S661.149-2016.547,663.452-2014.9Z",
    transform: "translate(-659.234 2017.886)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(119.759 79.846)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M657.515-2024.848c1.9,1.683,3.671,2.827,3.783,2.664a23.859,23.859,0,0,0-3.345-3.155c-1.906-1.69-3.72-2.779-3.825-2.612A28.521,28.521,0,0,0,657.515-2024.848Z",
    transform: "translate(-654.125 2027.968)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M695.858-2031.986l24.788,11.24a4.853,4.853,0,0,0,6.425-2.416l1.956-4.311a4.854,4.854,0,0,0-2.416-6.425l-24.788-11.24a4.854,4.854,0,0,0-6.425,2.416l-1.955,4.311A4.854,4.854,0,0,0,695.858-2031.986Z",
    transform: "translate(-198.192 2250.855)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M6.166,0H7.888a6.165,6.165,0,0,1,6.165,6.165v23.6A6.165,6.165,0,0,1,7.888,35.93H6.165A6.165,6.165,0,0,1,0,29.765V6.166A6.166,6.166,0,0,1,6.166,0Z",
    transform: "translate(480.407 261.981) rotate(-65.609)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(183.472)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M396.512-2289.251a23.807,23.807,0,0,1,29.588-16.066,23.806,23.806,0,0,1,14.77,12.667c3.864,8.135,3.328,18.707,10.064,24.693,0,0,10.887,5.974,3.628,30.144a25.2,25.2,0,0,1-1.5,3.7c-.868,1.8-2.028,5.976.237,13.459,1.564,4.871-1.336,10.3-5.551,13.2s-9.457,3.815-14.529,4.5c-12.221,1.643-23.718,33.074-35.64,29.9-10.763-2.863-6.352-38.675-23.77-49.463a27.963,27.963,0,0,1-9.833-10.589q-.19-.353-.4-.724c-4.737-9.159-5.614-20.817-5.417-29.619a49.473,49.473,0,0,1,6.53-23.852,24.526,24.526,0,0,1,7.823-8.715,17.52,17.52,0,0,1,24.18,5.415,17.517,17.517,0,0,1,1.835,3.871",
    transform: "translate(-310.447 2306.304)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M381.837-2267.232l-.05-6.714,40.4-7.171c12.45-1.165,25.714,11.428,26.379,23.95.714,13.871,1.029,30.843-.714,41.165-3.571,20.764-19.529,23.215-19.529,23.215l-.542,25.414-22.458,62.457-24.2-68.486Z",
    transform: "translate(-315.336 2300.963)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M455.757-2230.364a2.665,2.665,0,0,1-2.6,2.657,2.543,2.543,0,0,1-2.717-2.356c0-.027,0-.053,0-.08a2.663,2.663,0,0,1,2.6-2.663,2.543,2.543,0,0,1,2.717,2.356Z",
    transform: "translate(-330.076 2290.675)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M458.248-2240.316c-.336.343-2.343-1.172-5.214-1.2s-5,1.386-5.293,1.028c-.15-.157.193-.786,1.115-1.428a7.376,7.376,0,0,1,4.25-1.25,7.014,7.014,0,0,1,4.143,1.393C458.119-2241.1,458.412-2240.467,458.248-2240.316Z",
    transform: "translate(-329.496 2292.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M423.314-2230.364a2.664,2.664,0,0,1-2.6,2.657,2.55,2.55,0,0,1-2.718-2.37c0-.022,0-.044,0-.066a2.657,2.657,0,0,1,2.6-2.663,2.542,2.542,0,0,1,2.716,2.356C423.311-2230.422,423.313-2230.394,423.314-2230.364Z",
    transform: "translate(-323.177 2290.675)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M422.394-2240.066c-.335.342-2.336-1.179-5.207-1.207s-5,1.386-5.3,1.028c-.15-.157.193-.779,1.121-1.428a7.275,7.275,0,0,1,4.243-1.257,7.09,7.09,0,0,1,4.143,1.428C422.294-2240.838,422.558-2240.224,422.394-2240.066Z",
    transform: "translate(-321.871 2292.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M437.867-2218.561c0-.165,1.779-.45,4.671-.786.714-.064,1.429-.207,1.557-.715a4.224,4.224,0,0,0-.457-2.179q-1.006-2.664-2.1-5.606c-2.921-7.979-5-14.543-4.693-14.658s2.942,6.265,5.857,14.286q1.05,2.95,2.007,5.636a4.306,4.306,0,0,1,.35,2.857,1.858,1.858,0,0,1-1.222,1.057,5.25,5.25,0,0,1-1.242.157C439.681-2218.39,437.874-2218.4,437.867-2218.561Z",
    transform: "translate(-327.18 2292.736)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M433.362-2170.966a54.731,54.731,0,0,1-28.479-7.814s6.85,14.643,28.4,13Z",
    transform: "translate(-320.389 2279.184)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M434.184-2203.87a5.15,5.15,0,0,0-4.615-1.97,4.7,4.7,0,0,0-3.278,1.707,3,3,0,0,0-.272,3.421,3.49,3.49,0,0,0,3.757.993,10.827,10.827,0,0,0,3.693-2.142,3.2,3.2,0,0,0,.828-.843.95.95,0,0,0,0-1.064",
    transform: "translate(-324.796 2284.945)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M427.26-2209.7c.465,0,.436,3.093,3.078,5.336s5.958,1.942,5.979,2.378c.043.193-.75.593-2.143.614a7.763,7.763,0,0,1-5-1.807,6.719,6.719,0,0,1-2.379-4.472C426.689-2208.956,427.046-2209.72,427.26-2209.7Z",
    transform: "translate(-325.045 2285.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M422.643-2250.188c-.293.779-3.15.372-6.529.714s-6.107,1.25-6.543.543c-.193-.336.286-1.065,1.393-1.808a11,11,0,0,1,4.872-1.635,10.829,10.829,0,0,1,5.085.657C422.157-2251.181,422.771-2250.56,422.643-2250.188Z",
    transform: "translate(-321.377 2294.849)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M458.493-2252.888c-.514.643-2.479-.057-4.857-.114s-4.4.386-4.857-.307c-.193-.329.128-.979,1.014-1.586a7.042,7.042,0,0,1,7.858.335C458.45-2253.867,458.707-2253.188,458.493-2252.888Z",
    transform: "translate(-329.713 2295.592)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M419.665-2280.982a22.144,22.144,0,0,1-15.793,18.843c-3.357.921-7.579,1.514-8.793,4.778-1.264,3.386,1.8,6.672,3.164,10a11.322,11.322,0,0,1-2.664,12.229c-1.836,1.722-4.229,2.786-5.972,4.607a11.173,11.173,0,0,0-2.728,9.286,16.034,16.034,0,0,0,4.593,8.721c-7.857.107-16.321-4.285-18.572-11.814-1.328-4.493-.335-9.286.486-13.928a175.776,175.776,0,0,0,2.678-31.915c0-1.815,0-3.779,1.079-5.229s2.922-1.987,4.643-2.443a262.3,262.3,0,0,1,34.172-6.672",
    transform: "translate(-313.449 2301.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M426.72-2284.667c2.014,4.072,4.078,8.222,7.243,11.479s7.679,5.536,12.143,4.9l-2.236-4.15a65.532,65.532,0,0,0,21.751,16.014c-3.815-7.978-7.758-16.143-14.143-22.257s-15.822-9.85-24.222-7.093",
    transform: "translate(-325.033 2302.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M444.005-2234.529a9.131,9.131,0,0,1,.25-2.908,11.722,11.722,0,0,1,4.286-6.643,11.892,11.892,0,0,1,5.043-2.292,12.076,12.076,0,0,1,6.336.493,12.143,12.143,0,0,1,5.636,4.192,12.008,12.008,0,0,1,0,14.286,11.326,11.326,0,0,1-2.564,2.557,11.119,11.119,0,0,1-3.064,1.635,11.92,11.92,0,0,1-11.378-1.8,11.735,11.735,0,0,1-4.286-6.636,9.128,9.128,0,0,1-.25-2.907,23.042,23.042,0,0,0,.493,2.856,11.741,11.741,0,0,0,4.285,6.336,11.533,11.533,0,0,0,10.915,1.6,10.838,10.838,0,0,0,2.9-1.572,10.635,10.635,0,0,0,2.422-2.443,11.431,11.431,0,0,0,0-13.571,10.616,10.616,0,0,0-2.422-2.443,10.823,10.823,0,0,0-2.9-1.571,11.625,11.625,0,0,0-6.036-.521,11.428,11.428,0,0,0-4.872,2.143,11.735,11.735,0,0,0-4.285,6.336C444.026-2235.579,444.126-2234.529,444.005-2234.529Z",
    transform: "translate(-328.704 2293.604)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M404.437-2234.529a8.971,8.971,0,0,1,.243-2.908,11.717,11.717,0,0,1,4.285-6.643,11.9,11.9,0,0,1,5.043-2.292,12.068,12.068,0,0,1,6.336.493,12.141,12.141,0,0,1,5.629,4.192,12.021,12.021,0,0,1,0,14.286,11.424,11.424,0,0,1-2.564,2.557,11.268,11.268,0,0,1-3.071,1.635,11.92,11.92,0,0,1-11.379-1.8,11.734,11.734,0,0,1-4.285-6.636,8.969,8.969,0,0,1-.243-2.907,27.847,27.847,0,0,0,.486,2.856,11.738,11.738,0,0,0,4.286,6.336,11.537,11.537,0,0,0,10.928,1.6,11.531,11.531,0,0,0,5.322-4.015,11.428,11.428,0,0,0,0-13.571,11.531,11.531,0,0,0-5.322-4.014,11.625,11.625,0,0,0-6.036-.521,11.415,11.415,0,0,0-4.864,2.143,11.711,11.711,0,0,0-4.286,6.336A27.9,27.9,0,0,0,404.437-2234.529Z",
    transform: "translate(-320.287 2293.604)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M434.184-2235.109c-.057-.05.257-.521,1.008-1.021a5.4,5.4,0,0,1,6.557.557c.657.615.886,1.136.821,1.171a10.824,10.824,0,0,1-1.107-.821,5.85,5.85,0,0,0-6.05-.507C434.677-2235.373,434.263-2235.037,434.184-2235.109Z",
    transform: "translate(-326.619 2291.562)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "M461.974-2221.724c-.079-.186,2.35-.9,4.285-3.164s2.379-4.729,2.571-4.679c.079,0,.093.643-.178,1.629a9.039,9.039,0,0,1-1.908,3.471,9.123,9.123,0,0,1-3.186,2.35A3.059,3.059,0,0,1,461.974-2221.724Z",
    transform: "translate(-332.53 2289.985)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "M422.528-2220.862c-.071-.186,2.357-.9,4.286-3.164s2.379-4.729,2.571-4.679a3.07,3.07,0,0,1-.179,1.629,9.209,9.209,0,0,1-5.1,5.822A3.056,3.056,0,0,1,422.528-2220.862Z",
    transform: "translate(-324.141 2289.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M462.435-2064.443l-.171-81.607-42.408-9.821s1.35,10.614-18.857,9.143-28.25-10.486-28.25-10.486l-31,9.2.85,15.979,3.515,68.293s-1.679,29.286-2.236,32.987,13.771,19.879,13.771,19.879l107.237-.6Z",
    transform: "translate(-306.962 2274.597)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M297.566-2071.559s14.822-48.958,18.372-56.208c5.414-11.072,12.143-16.893,16.893-17.994s4.286,84.473,4.286,84.473S303.445-2062.744,297.566-2071.559Z",
    transform: "translate(-297.566 2272.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M525.707-2074.481c1.5-2.521-20.886-67.858-32.278-68.572v82.215Z",
    transform: "translate(-339.22 2271.585)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M487.968-2112.5c.493,2.128,1.228,5.207,1.864,9.057s1.186,8.472,1.572,13.622.607,10.822.779,16.786.321,11.678.614,16.814.665,9.843.921,13.708.457,7.007.6,9.236c.065,1.086.114,1.893.15,2.514a6.985,6.985,0,0,0,.086.879,4.68,4.68,0,0,0,0-.879c-.05-.621-.05-1.464-.05-2.521-.072-2.186-.207-5.343-.435-9.25s-.536-8.543-.815-13.708-.4-10.843-.578-16.807-.4-11.643-.815-16.807-1.028-9.793-1.686-13.65-1.479-6.9-2.035-9.043c-.286-1.014-.536-1.814-.715-2.407a6.2,6.2,0,0,0-.293-.829,5.034,5.034,0,0,0,.186.857C487.475-2114.334,487.689-2113.527,487.968-2112.5Z",
    transform: "translate(-337.881 2265.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M339.733-2114.771a28.022,28.022,0,0,1-.794-2.857,65.825,65.825,0,0,0-2.264-6.892,67.756,67.756,0,0,0-3.036-6.593,22.645,22.645,0,0,1-1.372-2.686,13.83,13.83,0,0,1,1.693,2.507,47.541,47.541,0,0,1,5.336,13.571A13.4,13.4,0,0,1,339.733-2114.771Z",
    transform: "translate(-304.946 2269.617)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M493.1-2140.359a12.329,12.329,0,0,1-.9,2.222c-.593,1.357-1.372,3.243-2.107,5.364s-1.293,4.086-1.672,5.514a13.191,13.191,0,0,1-.672,2.307,9.727,9.727,0,0,1,.314-2.386,43.284,43.284,0,0,1,1.536-5.606,42.534,42.534,0,0,1,2.264-5.365A9.838,9.838,0,0,1,493.1-2140.359Z",
    transform: "translate(-338.012 2271.013)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M341.961-2104.351a2.059,2.059,0,0,1,.079.557c0,.428.065.958.114,1.607.093,1.471.214,3.479.365,5.928.314,5,.772,11.908,1.428,19.522s1.329,14.507,1.85,19.493c.257,2.436.472,4.436.621,5.9.065.65.115,1.178.15,1.607a2.257,2.257,0,0,1,0,.564,2.2,2.2,0,0,1-.121-.55c-.065-.422-.15-.95-.25-1.6-.207-1.386-.472-3.393-.786-5.878-.614-5-1.364-11.864-2-19.494s-1.043-14.536-1.257-19.549c-.107-2.5-.172-4.529-.2-5.929v-1.615A2.509,2.509,0,0,1,341.961-2104.351Z",
    transform: "translate(-307.003 2263.355)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(33.118 161.168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.662-2101.6c-3.436,15.586-2.857,33.022,4.386,48.251C343.977-2069.937,341.662-2101.6,341.662-2101.6Z",
    transform: "translate(-339.63 2101.602)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M498.021-1987.111c12.715-2.471,14.614-11.771,15.044-18.306s-2.243-47.965-2.243-47.965l-26.014,11.021L486.014-2017s-6.193,5.043-9.05,5.643c-1.157.242-6.057-1.664-10.486-2.721-6.829-1.622-20.015,7.029-19.593,14.043l8.371,6.729S485.307-1984.638,498.021-1987.111Z",
    transform: "translate(-329.319 2252.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M508.546-2008.879a10.232,10.232,0,0,1,4.085,2.464,11.6,11.6,0,0,1,2.3,3.2,18.134,18.134,0,0,1,1.1,3.5,3.113,3.113,0,0,0-.036-1.007,9.468,9.468,0,0,0-.714-2.65,11.149,11.149,0,0,0-2.293-3.379,10.294,10.294,0,0,0-4.285-2.621,15.372,15.372,0,0,0-8.979,0,7.8,7.8,0,0,0-2.443,1.257,2.906,2.906,0,0,0-.714.714,10.712,10.712,0,0,1,3.271-1.643A15.956,15.956,0,0,1,508.546-2008.879Z",
    transform: "translate(-339.888 2243.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M324.566-1977.493c12.757,2.079,42.543-7.606,42.543-7.606l17.143-8.479-12.443-11.664a14.029,14.029,0,0,0-14.222-3.007c-5.229,1.822-11.428,3.778-12.964,3.5a76.013,76.013,0,0,1-7.893-2.143l2.236-32.985-30.822-5.193s.171,43.293.807,49.786S311.809-1979.572,324.566-1977.493Z",
    transform: "translate(-299.816 2250.748)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M322.072-1996.486a9.71,9.71,0,0,1,4.285-2.508,18.624,18.624,0,0,1,9.136.079,11.7,11.7,0,0,1,3.464,1.586c.014-.015-.065-.087-.179-.229a4.206,4.206,0,0,0-.6-.507,8.8,8.8,0,0,0-2.593-1.222,17.866,17.866,0,0,0-9.372-.228,9.952,9.952,0,0,0-4.485,2.671,11.265,11.265,0,0,0-2.357,3.571,9.646,9.646,0,0,0-.715,2.778,3.557,3.557,0,0,0,0,1.05,16.978,16.978,0,0,1,1.057-3.678A11.374,11.374,0,0,1,322.072-1996.486Z",
    transform: "translate(-302.043 2241.169)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.798 167.496)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.289 3.21)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M415.249-2089.488a48.987,48.987,0,0,0-48.987,48.987,48.987,48.987,0,0,0,48.987,48.987,48.987,48.987,0,0,0,48.987-48.987A48.987,48.987,0,0,0,415.249-2089.488Zm-6.5,56.959a7.972,7.972,0,0,1-7.972-7.972,7.973,7.973,0,0,1,7.972-7.973,7.973,7.973,0,0,1,7.973,7.973A7.972,7.972,0,0,1,408.744-2032.529Z",
    transform: "translate(-366.262 2089.488)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(4.289 4.815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.249-2087.449a48.986,48.986,0,0,0-48.987,48.986,48.987,48.987,0,0,0,48.987,48.987,48.987,48.987,0,0,0,48.987-48.987A48.986,48.986,0,0,0,415.249-2087.449Zm-6.5,56.959a7.973,7.973,0,0,1-7.972-7.973,7.973,7.973,0,0,1,7.972-7.972,7.972,7.972,0,0,1,7.973,7.972A7.972,7.972,0,0,1,408.744-2030.49Z",
    transform: "translate(-366.262 2087.449)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M409.8-2093.565a48.988,48.988,0,0,0-48.987,48.987,48.987,48.987,0,0,0,48.987,48.987,48.987,48.987,0,0,0,48.987-48.987A48.988,48.988,0,0,0,409.8-2093.565Zm-.666,56.959a7.972,7.972,0,0,1-7.972-7.972,7.972,7.972,0,0,1,7.972-7.973,7.972,7.972,0,0,1,7.973,7.973A7.972,7.972,0,0,1,409.136-2036.606Z",
    transform: "translate(-360.815 2093.565)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(50.125 21.541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.479-2008.92c.839.074,1.687.119,2.545.119a28.7,28.7,0,0,0,28.7-28.7,28.7,28.7,0,0,0-28.7-28.7c-.858,0-1.706.045-2.545.119a28.7,28.7,0,0,1,26.156,28.583A28.7,28.7,0,0,1,424.479-2008.92Z",
    transform: "translate(-424.479 2066.205)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.258 21.1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M395.9-2014.145a27.4,27.4,0,0,0,7.406,3.957,29.191,29.191,0,0,0,15.332,1.208,28.781,28.781,0,0,0,12.221-5.519,28.575,28.575,0,0,0,10.409-16.063,20.2,20.2,0,0,0,.535-3,13.13,13.13,0,0,0,.172-2.223,11.388,11.388,0,0,0-.018-1.836,51.25,51.25,0,0,1-1.105,6.955,28.6,28.6,0,0,1-10.465,15.549,28.152,28.152,0,0,1-11.916,5.24,28.386,28.386,0,0,1-14.819-1.263,26.528,26.528,0,0,1-7.127-3.848,26.475,26.475,0,0,1-5.951-5.99,28.308,28.308,0,0,1-5.47-16.647,28.308,28.308,0,0,1,5.473-16.643,26.45,26.45,0,0,1,5.95-5.988,26.474,26.474,0,0,1,7.125-3.846,28.374,28.374,0,0,1,14.818-1.264,28.161,28.161,0,0,1,11.916,5.24,28.606,28.606,0,0,1,10.467,15.549,51.267,51.267,0,0,1,1.105,6.956,11.39,11.39,0,0,0,.018-1.836,13.134,13.134,0,0,0-.172-2.223,20.2,20.2,0,0,0-.535-3,28.581,28.581,0,0,0-10.411-16.064,28.775,28.775,0,0,0-12.221-5.518,29.182,29.182,0,0,0-15.33,1.208,27.435,27.435,0,0,0-7.4,3.955,27.422,27.422,0,0,0-6.193,6.194,29.294,29.294,0,0,0-5.7,17.281,29.3,29.3,0,0,0,5.7,17.286A27.4,27.4,0,0,0,395.9-2014.145Z",
    transform: "translate(-384.005 2066.766)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.601 245.728)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M372.354-1974.073s1.736,4.95,4.343,6.922a18.007,18.007,0,0,0,6.836,2.636,8.522,8.522,0,0,0,5.222,4.208c3.586.842,6.751-1.714,6.751-1.714a10.025,10.025,0,0,0,4.878,1.364c2.207-.2,4.05.086,4.35-1.535s1.429-6.757,1.429-6.757,4.235.264,4.735-2.029c.343-1.586.2-6.121.086-8.78a2.767,2.767,0,0,0-.22-1.015,2.771,2.771,0,0,0-3.637-1.463h-.072s.143-4.164-3.649-4.164a5.408,5.408,0,0,0-2.6,1.879s-.521-3.286-3.143-3.786-4.2,1.992-4.764,3.5a2.74,2.74,0,0,0-2.528-2.908c-2.779-.493-5.107,2.922-5.822,4.429a50.765,50.765,0,0,1-12.608-9.835,18.451,18.451,0,0,0-3.129,3.828l-1.086,12.307A6.776,6.776,0,0,0,372.354-1974.073Z",
    transform: "translate(-367.087 1993.972)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M368.189-1975.456a7.4,7.4,0,0,0,1.272,1.1,4.759,4.759,0,0,0,2.862.887,14.685,14.685,0,0,0,4.109,6.47,7.672,7.672,0,0,0,1.908,1.215,3.727,3.727,0,0,0,.771.25,12.615,12.615,0,0,1-2.486-1.664,15.174,15.174,0,0,1-3.9-6.557l-.065-.186h-.186c-1.857.142-3.829-1.322-4.807-3.15a3.055,3.055,0,0,1-.208-1.593c.093-.572.186-1.129.272-1.686l.514-3.2c.307-2.007.593-3.835.836-5.407a6.25,6.25,0,0,1,.957-1.765c.357-.506.672-.935.936-1.278a8.062,8.062,0,0,0,.793-1.093,6.229,6.229,0,0,0-.95.971c-.3.329-.628.736-1.014,1.236a6.166,6.166,0,0,0-1.086,1.879c-.279,1.571-.593,3.393-.95,5.4l-.535,3.185-.279,1.693a3.483,3.483,0,0,0,.236,1.865A4.6,4.6,0,0,0,368.189-1975.456Z",
    transform: "translate(-366.915 1993.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M379-1980.176a6.62,6.62,0,0,1,2.036,3.885,4.479,4.479,0,0,1-1.529,3.936,3.354,3.354,0,0,1-1.693.822,4.219,4.219,0,0,1-1.672-.107,9.882,9.882,0,0,0-2.528-.486,1.521,1.521,0,0,0-.929.235,9.057,9.057,0,0,1,.921,0,12.247,12.247,0,0,1,2.45.629,4.29,4.29,0,0,0,1.822.186,3.9,3.9,0,0,0,1.935-.879,4.928,4.928,0,0,0,1.736-4.371,6.912,6.912,0,0,0-2.222-4.171,9.651,9.651,0,0,0-3.328-1.95,15.054,15.054,0,0,0-2.493-.657,2.836,2.836,0,0,0-.942-.086c-.021.093,1.314.3,3.307,1.057A9.779,9.779,0,0,1,379-1980.176Z",
    transform: "translate(-368.116 1991.862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M388.554-1962.891a24.043,24.043,0,0,0,1.528-1.886,39.732,39.732,0,0,0,4.071-6.928,38.562,38.562,0,0,0,2.579-7.579,22.053,22.053,0,0,0,.414-2.386,2.856,2.856,0,0,0,.043-.893c-.079-.014-.286,1.235-.814,3.214a47.812,47.812,0,0,1-2.715,7.443,49.612,49.612,0,0,1-3.878,6.914c-1.157,1.686-1.9,2.7-1.871,2.721S388.168-1962.469,388.554-1962.891Z",
    transform: "translate(-371.38 1991.727)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M404.388-1962.806a59.773,59.773,0,0,0,2.4-7.857,66.15,66.15,0,0,0,1.335-8.129c.1-1.057.179-1.9.179-2.486a3.115,3.115,0,0,0,0-.921,28.287,28.287,0,0,0-.542,3.357c-.3,2.079-.757,4.943-1.479,8.05s-1.564,5.879-2.236,7.858a32.61,32.61,0,0,0-1.064,3.236,3,3,0,0,0,.436-.808C403.673-1961.042,404.009-1961.821,404.388-1962.806Z",
    transform: "translate(-374.585 1991.649)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M416.659-1967.167a44.55,44.55,0,0,0,.714-5,45.88,45.88,0,0,0,.179-5.043,7.133,7.133,0,0,0-.208-2.086c-.143.007-.121,3.2-.493,7.092s-.864,7.065-.714,7.065A7.857,7.857,0,0,0,416.659-1967.167Z",
    transform: "translate(-377.377 1991.032)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M385.167-1975.351a39.165,39.165,0,0,0,1.886-3.643,4.146,4.146,0,0,0,.5-1.636,9.462,9.462,0,0,0-.836,1.479c-.493.907-1.207,2.164-2,3.536-.736,1.264-1.407,2.408-2.057,3.514a7.194,7.194,0,0,0-.8,1.5C382-1970.5,383.581-1972.58,385.167-1975.351Z",
    transform: "translate(-370.093 1991.316)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M390.195-1983.84a7.476,7.476,0,0,1,1.707-1.75,4.061,4.061,0,0,1,3.007-.714,3.166,3.166,0,0,1,1.786.779,2.271,2.271,0,0,1,.594,1.827c-.006.02-.017.038-.023.058l.019.006c0,.024,0,.048,0,.072l.335.064c0-.009.008-.017.01-.027l.039.013c.007-.043,0-.086.006-.129a4.989,4.989,0,0,1,2.087-2.713,3.955,3.955,0,0,1,3.728-.122,3.05,3.05,0,0,1,1.429,1.3,3.125,3.125,0,0,1,.242,1.871l-.1.714.429-.585a4.99,4.99,0,0,1,1.893-1.736,1.133,1.133,0,0,1,.55-.079c.214.029.422.057.622.1a5.016,5.016,0,0,1,1.15.35,2.78,2.78,0,0,1,1.486,1.543,4.994,4.994,0,0,1,.272,1.992v.229l.207-.1a2.639,2.639,0,0,1,2.422-.043,3.106,3.106,0,0,1,1.142,1.515,7.7,7.7,0,0,1,.321,1.207,1.949,1.949,0,0,0,.108.428,2.054,2.054,0,0,0-.05-.464,5.793,5.793,0,0,0-.265-1.242,3.087,3.087,0,0,0-1.171-1.642,2.8,2.8,0,0,0-2.46-.073,5.152,5.152,0,0,0-.248-1.942,3.084,3.084,0,0,0-1.635-1.735,5.508,5.508,0,0,0-1.222-.386c-.207-.043-.421-.072-.635-.107a1.531,1.531,0,0,0-.714.092,5.2,5.2,0,0,0-1.726,1.452,3.544,3.544,0,0,0-.289-1.565,3.454,3.454,0,0,0-1.607-1.472,4.3,4.3,0,0,0-2.086-.435,4.59,4.59,0,0,0-1.986.586,5.326,5.326,0,0,0-1.953,2.165,2.578,2.578,0,0,0-.661-1.216,3.453,3.453,0,0,0-1.993-.835,4.285,4.285,0,0,0-3.193.807,7.306,7.306,0,0,0-1.708,1.85,9.233,9.233,0,0,0-.764,1.393,1.733,1.733,0,0,0-.186.528,4.012,4.012,0,0,0,.264-.485A10.8,10.8,0,0,1,390.195-1983.84Z",
    transform: "translate(-371.635 1992.733)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M469.9-1994.2a50.724,50.724,0,0,1-12.6,9.843c-.714-1.515-3.049-4.929-5.828-4.436a2.74,2.74,0,0,0-2.529,2.908c-.565-1.5-2.143-4-4.764-3.5s-3.143,3.793-3.143,3.793a5.434,5.434,0,0,0-2.593-1.886c-3.8,0-3.657,4.171-3.657,4.171h-.072a2.771,2.771,0,0,0-3.632,1.473,2.764,2.764,0,0,0-.218,1.005c-.121,2.665-.257,7.193.086,8.779.493,2.3,4.736,2.028,4.736,2.028s1.128,5.143,1.428,6.757,2.143,1.336,4.357,1.535a10.133,10.133,0,0,0,4.872-1.313s3.164,2.557,6.75,1.714a8.5,8.5,0,0,0,5.229-4.2,18.111,18.111,0,0,0,6.829-2.637c2.607-1.964,4.343-6.928,4.343-6.928a6.781,6.781,0,0,0,4.629-2.908l-1.093-12.371A18.2,18.2,0,0,0,469.9-1994.2Z",
    transform: "translate(-380.486 1994.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M483.027-1981.521l-.535-3.179c-.35-2.008-.672-3.835-.95-5.407a6.045,6.045,0,0,0-1.086-1.879c-.379-.492-.714-.907-1.014-1.235a5.847,5.847,0,0,0-.95-.972,7.519,7.519,0,0,0,.793,1.1c.265.35.586.771.936,1.278a6.53,6.53,0,0,1,.964,1.764c.243,1.579.522,3.4.836,5.407.157,1.028.328,2.1.507,3.207.086.55.179,1.115.272,1.686a3.058,3.058,0,0,1-.2,1.593c-.979,1.822-2.957,3.286-4.815,3.143H477.6l-.057.193a15.188,15.188,0,0,1-3.907,6.551,12.189,12.189,0,0,1-2.493,1.656,2.887,2.887,0,0,0,.772-.242,8.088,8.088,0,0,0,1.914-1.215,14.767,14.767,0,0,0,4.107-6.471,4.833,4.833,0,0,0,2.864-.893,7.669,7.669,0,0,0,1.272-1.1,4.7,4.7,0,0,0,1.008-1.429,3.573,3.573,0,0,0,.228-1.864Z",
    transform: "translate(-389.081 1994.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M475.257-1983.212c1.971-.757,3.329-.964,3.3-1.057a2.992,2.992,0,0,0-.935.093,14.9,14.9,0,0,0-2.5.65,9.663,9.663,0,0,0-3.321,1.957,6.9,6.9,0,0,0-2.229,4.171,4.913,4.913,0,0,0,1.736,4.364,3.815,3.815,0,0,0,1.935.879,4.379,4.379,0,0,0,1.822-.179,12.594,12.594,0,0,1,2.45-.636c.586-.042.914.079.921,0a1.519,1.519,0,0,0-.921-.228,9.863,9.863,0,0,0-2.536.479,4.188,4.188,0,0,1-1.671.114,3.506,3.506,0,0,1-1.693-.821,4.53,4.53,0,0,1-1.529-3.943,6.61,6.61,0,0,1,2.043-3.885A9.93,9.93,0,0,1,475.257-1983.212Z",
    transform: "translate(-388.739 1992.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M454.363-1980.356a38.434,38.434,0,0,0,2.593,7.572,39.528,39.528,0,0,0,4.05,6.907c.614.828,1.143,1.464,1.529,1.886s.614.643.642.622-.714-1.029-1.871-2.715a50.1,50.1,0,0,1-3.878-6.914,47.22,47.22,0,0,1-2.707-7.443c-.572-1.964-.772-3.215-.822-3.2a2.851,2.851,0,0,0,.043.892A20.325,20.325,0,0,0,454.363-1980.356Z",
    transform: "translate(-385.41 1991.956)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M445.32-1971.741a58.862,58.862,0,0,0,2.393,7.858c.379.985.715,1.771.972,2.3a3.28,3.28,0,0,0,.436.807,30.605,30.605,0,0,0-1.064-3.229c-.672-1.986-1.514-4.757-2.236-7.857s-1.214-5.972-1.493-8.065a28.331,28.331,0,0,0-.521-3.342,3.011,3.011,0,0,0,0,.913c0,.593.079,1.428.186,2.493A64.821,64.821,0,0,0,445.32-1971.741Z",
    transform: "translate(-383.26 1991.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M436.475-1968.245a8.091,8.091,0,0,0,.522,2.028c.15,0-.343-3.171-.715-7.071s-.321-7.071-.464-7.079a7.073,7.073,0,0,0-.208,2.086,44.439,44.439,0,0,0,.186,5.036C435.968-1971.281,436.233-1969.517,436.475-1968.245Z",
    transform: "translate(-381.523 1991.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M467.3-1976.694c-.793-1.379-1.5-2.628-2-3.57a9.865,9.865,0,0,0-.829-1.472,3.849,3.849,0,0,0,.5,1.629,36.173,36.173,0,0,0,1.879,3.642c1.593,2.8,3.171,4.886,3.307,4.779a6.83,6.83,0,0,0-.8-1.493Z",
    transform: "translate(-387.662 1991.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M431.131-1980.5a3.011,3.011,0,0,1,1.135-1.514,2.615,2.615,0,0,1,2.422.042l.207.1v-.229a4.83,4.83,0,0,1,.264-1.993,2.761,2.761,0,0,1,1.493-1.55,4.826,4.826,0,0,1,1.143-.35l.621-.1a1.256,1.256,0,0,1,.557.078,5.038,5.038,0,0,1,1.863,1.6c0,.018,0,.037,0,.057l.035-.015c.017.023.041.04.057.064l.428.594-.1-.714a3.166,3.166,0,0,1,.243-1.871,3.065,3.065,0,0,1,1.428-1.308,3.961,3.961,0,0,1,3.729.128,4.994,4.994,0,0,1,2.088,2.716c0,.035,0,.071,0,.105l.034-.006c0,.015.012.028.017.042l.335-.064a2.256,2.256,0,0,1,.579-1.964,3.175,3.175,0,0,1,1.793-.772,4.071,4.071,0,0,1,3,.714,7.5,7.5,0,0,1,1.708,1.75,12.631,12.631,0,0,1,.828,1.343,4.18,4.18,0,0,0,.265.493,2.045,2.045,0,0,0-.186-.528,9.263,9.263,0,0,0-.772-1.429,7.306,7.306,0,0,0-1.707-1.85,4.289,4.289,0,0,0-3.186-.8,3.4,3.4,0,0,0-1.993.835,2.568,2.568,0,0,0-.69,1.359,5.259,5.259,0,0,0-1.982-2.244,4.443,4.443,0,0,0-1.986-.586,4.153,4.153,0,0,0-2.086.435,3.438,3.438,0,0,0-1.614,1.472,3.5,3.5,0,0,0-.285,1.563,5.241,5.241,0,0,0-1.723-1.456,1.461,1.461,0,0,0-.714-.086c-.207.028-.421.057-.635.107a5.185,5.185,0,0,0-1.222.379,3.106,3.106,0,0,0-1.635,1.735,5.262,5.262,0,0,0-.247,1.94,2.845,2.845,0,0,0-2.46.075,3.187,3.187,0,0,0-1.172,1.65,5.708,5.708,0,0,0-.257,1.235,1.859,1.859,0,0,0-.035.443,1.809,1.809,0,0,0,.078-.429A7.739,7.739,0,0,1,431.131-1980.5Z",
    transform: "translate(-380.485 1992.961)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject10);
export default __webpack_public_path__ + "static/media/project10.ece4b1ca1b71f2e2a515fe09f51666c9.svg";
export { ForwardRef as ReactComponent };